const data = [
  {
    "idx_id": 0,
    "vn": "Chuột",
    "en": "mice",
    "tw": "鼠",
    "cn": "鼠",
    "pinin": "shǔ"
  },
  {
    "idx_id": 0,
    "vn": "Trâu",
    "en": "xo",
    "tw": "牛",
    "cn": "牛",
    "pinin": "niú"
  },
  {
    "idx_id": 0,
    "vn": "Hổ",
    "en": "tiger",
    "tw": "虎",
    "cn": "虎",
    "pinin": "hǔ"
  },
  {
    "idx_id": 0,
    "vn": "Mèo",
    "en": "cat",
    "tw": "貓",
    "cn": "猫",
    "pinin": "māo"
  },
  {
    "idx_id": 0,
    "vn": "Rồng",
    "en": "dragon",
    "tw": "龍",
    "cn": "龙",
    "pinin": "lóng"
  },
  {
    "idx_id": 0,
    "vn": "Rắn",
    "en": "snake",
    "tw": "蛇",
    "cn": "蛇",
    "pinin": "shé"
  },
  {
    "idx_id": 0,
    "vn": "Ngựa",
    "en": "horse",
    "tw": "馬",
    "cn": "马",
    "pinin": "mǎ"
  },
  {
    "idx_id": 0,
    "vn": "Dê",
    "en": "goat",
    "tw": "羊",
    "cn": "羊",
    "pinin": "yáng"
  },
  {
    "idx_id": 0,
    "vn": "Khỉ",
    "en": "monkey",
    "tw": "猴",
    "cn": "猴",
    "pinin": "hóu"
  },
  {
    "idx_id": 0,
    "vn": "Gà Trống",
    "en": "rooster",
    "tw": "雞",
    "cn": "鸡",
    "pinin": "jī"
  },
  {
    "idx_id": 0,
    "vn": "Chó",
    "en": "dog",
    "tw": "狗",
    "cn": "狗",
    "pinin": "gǒu"
  },
  {
    "idx_id": 0,
    "vn": "Lợn",
    "en": "pig",
    "tw": "豬",
    "cn": "猪",
    "pinin": "zhū"
  },
  {
    "idx_id": 1,
    "vn": "anh đào",
    "en": "cherry",
    "tw": "櫻桃",
    "cn": "樱桃",
    "pinin": "yīng táo"
  },
  {
    "idx_id": 1,
    "vn": "táo",
    "en": "apple",
    "tw": "蘋果",
    "cn": "苹果",
    "pinin": "pín guǒ"
  },
  {
    "idx_id": 1,
    "vn": "cam",
    "en": "orange",
    "tw": "橘子",
    "cn": "橘子",
    "pinin": "jú zǐ"
  },
  {
    "idx_id": 1,
    "vn": "dâu tây",
    "en": "strawberry",
    "tw": "草莓",
    "cn": "草莓",
    "pinin": "cǎo méi"
  },
  {
    "idx_id": 1,
    "vn": "dưa",
    "en": "melon",
    "tw": "哈蜜瓜",
    "cn": "哈蜜瓜",
    "pinin": "hā mì guā"
  },
  {
    "idx_id": 1,
    "vn": "dứa",
    "en": "pineapple",
    "tw": "鳳梨",
    "cn": "凤梨",
    "pinin": "fèng lí"
  },
  {
    "idx_id": 1,
    "vn": "dừa",
    "en": "coconut",
    "tw": "椰子",
    "cn": "椰子",
    "pinin": "yē zǐ"
  },
  {
    "idx_id": 1,
    "vn": "dưa hấu",
    "en": "watermelon",
    "tw": "西瓜",
    "cn": "西瓜",
    "pinin": "xī guā"
  },
  {
    "idx_id": 1,
    "vn": "roi",
    "en": "wax apple",
    "tw": "蓮霧",
    "cn": "莲雾",
    "pinin": "lián wù"
  },
  {
    "idx_id": 1,
    "vn": "xoài",
    "en": "mango",
    "tw": "芒果",
    "cn": "芒果",
    "pinin": "máng guǒ"
  },
  {
    "idx_id": 1,
    "vn": "thang long",
    "en": "dragon fruit",
    "tw": "火龍果",
    "cn": "火龙果",
    "pinin": "huǒ lóng guǒ"
  },
  {
    "idx_id": 1,
    "vn": "nho",
    "en": "grape",
    "tw": "葡萄",
    "cn": "葡萄",
    "pinin": "pú táo"
  },
  {
    "idx_id": 2,
    "vn": "xích lô",
    "en": "rickshaw",
    "tw": "人力車",
    "cn": "人力车",
    "pinin": "rén lì chē"
  },
  {
    "idx_id": 2,
    "vn": "xe đạp",
    "en": "bicycle",
    "tw": "腳踏車",
    "cn": "脚踏车",
    "pinin": "jiǎo tà chē"
  },
  {
    "idx_id": 2,
    "vn": "xe máy",
    "en": "motobike",
    "tw": "機車",
    "cn": "机车",
    "pinin": "jī chē"
  },
  {
    "idx_id": 2,
    "vn": "ô tô",
    "en": "car",
    "tw": "汽車",
    "cn": "汽车",
    "pinin": "qì chē"
  },
  {
    "idx_id": 2,
    "vn": "xe tải",
    "en": "truck",
    "tw": "卡車",
    "cn": "卡车",
    "pinin": "kǎ chē"
  },
  {
    "idx_id": 2,
    "vn": "xe buýt",
    "en": "bus",
    "tw": "巴士",
    "cn": "巴士",
    "pinin": "bā shì"
  },
  {
    "idx_id": 2,
    "vn": "xe cấp cưu",
    "en": "ambulance",
    "tw": "救護車",
    "cn": "救护车",
    "pinin": "jiù hù chē"
  },
  {
    "idx_id": 2,
    "vn": "tàu hỏa",
    "en": "train",
    "tw": "火車",
    "cn": "火车",
    "pinin": "huǒ chē"
  },
  {
    "idx_id": 2,
    "vn": "tàu thủy",
    "en": "ship",
    "tw": "船",
    "cn": "船",
    "pinin": "chuán"
  },
  {
    "idx_id": 2,
    "vn": "thuyền",
    "en": "boat",
    "tw": "艇",
    "cn": "艇",
    "pinin": "tǐng"
  },
  {
    "idx_id": 2,
    "vn": "máy bay",
    "en": "airplane",
    "tw": "飛機",
    "cn": "飞机",
    "pinin": "fēi jī"
  },
  {
    "idx_id": 2,
    "vn": "trực thăng",
    "en": "helicopter",
    "tw": "直升機",
    "cn": "直升机",
    "pinin": "zhí shēng jī"
  },
  {
    "idx_id": 3,
    "vn": "tim",
    "en": "heart",
    "tw": "心",
    "cn": "心",
    "pinin": "xīn"
  },
  {
    "idx_id": 3,
    "vn": "gan",
    "en": "liver",
    "tw": "肝",
    "cn": "肝",
    "pinin": "gān"
  },
  {
    "idx_id": 3,
    "vn": "lá lách",
    "en": "spleen",
    "tw": "脾",
    "cn": "脾",
    "pinin": "pí"
  },
  {
    "idx_id": 3,
    "vn": "phổi",
    "en": "lung",
    "tw": "肺",
    "cn": "肺",
    "pinin": "fèi"
  },
  {
    "idx_id": 3,
    "vn": "thận",
    "en": "kidney",
    "tw": "腎",
    "cn": "肾",
    "pinin": "shèn"
  },
  {
    "idx_id": 3,
    "vn": "dạ dày",
    "en": "stomach",
    "tw": "胃",
    "cn": "胃",
    "pinin": "wèi"
  },
  {
    "idx_id": 3,
    "vn": "tuyến tụy",
    "en": "pancreas",
    "tw": "胰臟",
    "cn": "胰脏",
    "pinin": "yí zàng"
  },
  {
    "idx_id": 3,
    "vn": "túi mật",
    "en": "gallbladder",
    "tw": "膽囊",
    "cn": "胆囊",
    "pinin": "dǎn náng"
  },
  {
    "idx_id": 3,
    "vn": "bọng đái",
    "en": "bladder",
    "tw": "膀胱",
    "cn": "膀胱",
    "pinin": "bǎng guāng"
  },
  {
    "idx_id": 3,
    "vn": "ruột già",
    "en": "the large intestine",
    "tw": "大腸",
    "cn": "大肠",
    "pinin": "dà cháng"
  },
  {
    "idx_id": 3,
    "vn": "ruột non",
    "en": "small intestines",
    "tw": "小腸",
    "cn": "小肠",
    "pinin": "xiǎo cháng"
  },
  {
    "idx_id": 3,
    "vn": "ruột thừa",
    "en": "appendix",
    "tw": "闌尾",
    "cn": "阑尾",
    "pinin": "lán wěi"
  },
  {
    "idx_id": 4,
    "vn": "trắng",
    "en": "white",
    "tw": "白",
    "cn": "白",
    "pinin": "bái"
  },
  {
    "idx_id": 4,
    "vn": "đen",
    "en": "black",
    "tw": "黑",
    "cn": "黑",
    "pinin": "hēi"
  },
  {
    "idx_id": 4,
    "vn": "vàng",
    "en": "yellow",
    "tw": "黃",
    "cn": "黄",
    "pinin": "huáng"
  },
  {
    "idx_id": 4,
    "vn": "vàng kim loại",
    "en": "golden",
    "tw": "金",
    "cn": "金",
    "pinin": "jīn"
  },
  {
    "idx_id": 4,
    "vn": "da cam",
    "en": "orange",
    "tw": "橘",
    "cn": "橘",
    "pinin": "jú"
  },
  {
    "idx_id": 4,
    "vn": "hồng",
    "en": "pink",
    "tw": "粉紅",
    "cn": "粉红",
    "pinin": "fěn hóng"
  },
  {
    "idx_id": 4,
    "vn": "đỏ",
    "en": "red",
    "tw": "紅",
    "cn": "红",
    "pinin": "hóng"
  },
  {
    "idx_id": 4,
    "vn": "nâu",
    "en": "brown",
    "tw": "棕",
    "cn": "棕",
    "pinin": "zōng"
  },
  {
    "idx_id": 4,
    "vn": "xanh lá cây",
    "en": "green",
    "tw": "綠",
    "cn": "绿",
    "pinin": "lǜ"
  },
  {
    "idx_id": 4,
    "vn": "xanh da trời",
    "en": "blue",
    "tw": "藍",
    "cn": "蓝",
    "pinin": "lán"
  },
  {
    "idx_id": 4,
    "vn": "tím",
    "en": "purple",
    "tw": "紫",
    "cn": "紫",
    "pinin": "zǐ"
  },
  {
    "idx_id": 4,
    "vn": "xám",
    "en": "gray",
    "tw": "灰",
    "cn": "灰",
    "pinin": "huī"
  },
  {
    "idx_id": 5,
    "vn": "bàn",
    "en": "table",
    "tw": "桌",
    "cn": "桌",
    "pinin": "zhuō"
  },
  {
    "idx_id": 5,
    "vn": "cái ghế",
    "en": "chair",
    "tw": "椅",
    "cn": "椅",
    "pinin": "yǐ"
  },
  {
    "idx_id": 5,
    "vn": "sách",
    "en": "book",
    "tw": "書",
    "cn": "书",
    "pinin": "shū"
  },
  {
    "idx_id": 5,
    "vn": "bút",
    "en": "pen",
    "tw": "筆",
    "cn": "笔",
    "pinin": "bǐ"
  },
  {
    "idx_id": 5,
    "vn": "kính mắt",
    "en": "glasses",
    "tw": "眼鏡",
    "cn": "眼镜",
    "pinin": "yǎn jìng"
  },
  {
    "idx_id": 5,
    "vn": "điện thoại di động",
    "en": "mobile phone",
    "tw": "手機",
    "cn": "手机",
    "pinin": "shǒu jī"
  },
  {
    "idx_id": 5,
    "vn": "cốc sứ",
    "en": "mug",
    "tw": "馬克杯",
    "cn": "马克杯",
    "pinin": "mǎ kè bēi"
  },
  {
    "idx_id": 5,
    "vn": "tranh treo",
    "en": "hanging painting",
    "tw": "掛畫",
    "cn": "挂画",
    "pinin": "guà huà"
  },
  {
    "idx_id": 5,
    "vn": "đèn bàn",
    "en": "table lamp",
    "tw": "桌燈",
    "cn": "桌灯",
    "pinin": "zhuō dēng"
  },
  {
    "idx_id": 5,
    "vn": "đồng hồ báo thức",
    "en": "alarm clock",
    "tw": "鬧鐘",
    "cn": "闹钟",
    "pinin": "nào zhōng"
  },
  {
    "idx_id": 5,
    "vn": "xương rồng",
    "en": "cactus",
    "tw": "仙人掌",
    "cn": "仙人掌",
    "pinin": "xiān rén zhǎng"
  },
  {
    "idx_id": 5,
    "vn": "giá sách",
    "en": "bookshelf",
    "tw": "書架",
    "cn": "书架",
    "pinin": "shū jià"
  },
  {
    "idx_id": 6,
    "vn": "cánh",
    "en": "wing",
    "tw": "翼",
    "cn": "翼",
    "pinin": "yì"
  },
  {
    "idx_id": 6,
    "vn": "bay",
    "en": "fly",
    "tw": "飛",
    "cn": "飞",
    "pinin": "fēi"
  },
  {
    "idx_id": 6,
    "vn": "khu vực nhận hành lý",
    "en": "baggage claim area",
    "tw": "行李認領區",
    "cn": "行李认领区",
    "pinin": "xíng lǐ rèn lǐng qū"
  },
  {
    "idx_id": 6,
    "vn": "băng chuyền hành lý",
    "en": "luggage carousel",
    "tw": "行李傳送帶",
    "cn": "行李传送带",
    "pinin": "xíng lǐ chuán sòng dài"
  },
  {
    "idx_id": 6,
    "vn": "ba lô",
    "en": "backpack",
    "tw": "背包",
    "cn": "背包",
    "pinin": "bēi bāo"
  },
  {
    "idx_id": 6,
    "vn": "túi xách",
    "en": "handbag",
    "tw": "手提包",
    "cn": "手提包",
    "pinin": "shǒu tí bāo"
  },
  {
    "idx_id": 6,
    "vn": "thẻ hành lý",
    "en": "luggage tag",
    "tw": "行李吊牌",
    "cn": "行李吊牌",
    "pinin": "xíng lǐ diào pái"
  },
  {
    "idx_id": 6,
    "vn": "thắt lưng hành lý",
    "en": "luggage belt",
    "tw": "行李帶",
    "cn": "行李带",
    "pinin": "xíng lǐ dài"
  },
  {
    "idx_id": 6,
    "vn": "xe đẩy hành lý",
    "en": "luggage cart",
    "tw": "行李手推車",
    "cn": "行李手推车",
    "pinin": "xíng lǐ shǒu tuī chē"
  },
  {
    "idx_id": 6,
    "vn": "vali",
    "en": "suitcase",
    "tw": "行李箱",
    "cn": "行李箱",
    "pinin": "xíng lǐ xiāng"
  },
  {
    "idx_id": 6,
    "vn": "khóa",
    "en": "lock",
    "tw": "鎖",
    "cn": "锁",
    "pinin": "suǒ"
  },
  {
    "idx_id": 6,
    "vn": "Tượng đá Đảo Phục Sinh",
    "en": "Easter Island Stone Statue",
    "tw": "復活島石像",
    "cn": "复活岛石像",
    "pinin": "fù huó dǎo shí xiàng"
  },
  {
    "idx_id": 7,
    "vn": "KimBap",
    "en": "KimBap",
    "tw": "紫菜包飯",
    "cn": "紫菜包饭",
    "pinin": "zǐ cài bāo fàn"
  },
  {
    "idx_id": 7,
    "vn": "cơm cuộn",
    "en": "rice roll",
    "tw": "飯卷",
    "cn": "饭卷",
    "pinin": "fàn juàn"
  },
  {
    "idx_id": 7,
    "vn": "cơm",
    "en": "cooked rice",
    "tw": "飯",
    "cn": "饭",
    "pinin": "fàn"
  },
  {
    "idx_id": 7,
    "vn": "rong biển",
    "en": "seaweed",
    "tw": "海苔",
    "cn": "海苔",
    "pinin": "hǎi tái"
  },
  {
    "idx_id": 7,
    "vn": "trứng",
    "en": "egg",
    "tw": "蛋",
    "cn": "蛋",
    "pinin": "dàn"
  },
  {
    "idx_id": 7,
    "vn": "dưa chuột",
    "en": "cucumber",
    "tw": "小黃瓜",
    "cn": "小黄瓜",
    "pinin": "xiǎo huáng guā"
  },
  {
    "idx_id": 7,
    "vn": "cà rốt",
    "en": "carrot",
    "tw": "紅蘿蔔",
    "cn": "红萝卜",
    "pinin": "hóng luó bǔ"
  },
  {
    "idx_id": 7,
    "vn": "thịt lợn",
    "en": "pork",
    "tw": "豬肉",
    "cn": "猪肉",
    "pinin": "zhū ròu"
  },
  {
    "idx_id": 7,
    "vn": "chảo",
    "en": "pan",
    "tw": "平底鍋",
    "cn": "平底锅",
    "pinin": "píng dǐ guō"
  },
  {
    "idx_id": 7,
    "vn": "bếp cảm ứng",
    "en": "induction cooker",
    "tw": "電磁爐",
    "cn": "电磁炉",
    "pinin": "diàn cí lú"
  },
  {
    "idx_id": 7,
    "vn": "con dao",
    "en": "knife",
    "tw": "刀",
    "cn": "刀",
    "pinin": "dāo"
  },
  {
    "idx_id": 7,
    "vn": "thớt",
    "en": "cutting board",
    "tw": "砧板",
    "cn": "砧板",
    "pinin": "zhēn bǎn"
  },
  {
    "idx_id": 8,
    "vn": "hoa cẩm chướng",
    "en": "Dianthus caryophyllus",
    "tw": "康乃馨",
    "cn": "康乃馨",
    "pinin": "kāng nǎi xīn"
  },
  {
    "idx_id": 8,
    "vn": "ôm",
    "en": "hug",
    "tw": "擁抱",
    "cn": "拥抱",
    "pinin": "yōng bào"
  },
  {
    "idx_id": 8,
    "vn": "thức dậy",
    "en": "wake up",
    "tw": "起床",
    "cn": "起床",
    "pinin": "qǐ chuáng"
  },
  {
    "idx_id": 8,
    "vn": "yêu",
    "en": "love",
    "tw": "愛",
    "cn": "爱",
    "pinin": "ài"
  },
  {
    "idx_id": 8,
    "vn": "lịch",
    "en": "calendar",
    "tw": "日曆",
    "cn": "日历",
    "pinin": "rì lì"
  },
  {
    "idx_id": 8,
    "vn": "sữa",
    "en": "milk",
    "tw": "牛奶",
    "cn": "牛奶",
    "pinin": "niú nǎi"
  },
  {
    "idx_id": 8,
    "vn": "lát bánh mì nướng",
    "en": "toast",
    "tw": "土司",
    "cn": "土司",
    "pinin": "tǔ sī"
  },
  {
    "idx_id": 8,
    "vn": "cốc sứ",
    "en": "mug",
    "tw": "馬克杯",
    "cn": "马克杯",
    "pinin": "mǎ kè bēi"
  },
  {
    "idx_id": 8,
    "vn": "giường",
    "en": "bed",
    "tw": "床",
    "cn": "床",
    "pinin": "chuáng"
  },
  {
    "idx_id": 8,
    "vn": "gối",
    "en": "pillow",
    "tw": "枕頭",
    "cn": "枕头",
    "pinin": "zhěn tou"
  },
  {
    "idx_id": 8,
    "vn": "truyền hình",
    "en": "TV",
    "tw": "電視",
    "cn": "电视",
    "pinin": "diàn shì"
  },
  {
    "idx_id": 8,
    "vn": "phòng khách",
    "en": "living room",
    "tw": "客廳",
    "cn": "客厅",
    "pinin": "kè tīng"
  },
  {
    "idx_id": 9,
    "vn": "đầu",
    "en": "head",
    "tw": "頭",
    "cn": "头",
    "pinin": "tóu"
  },
  {
    "idx_id": 9,
    "vn": "cổ",
    "en": "neck",
    "tw": "脖子",
    "cn": "脖子",
    "pinin": "bó zǐ"
  },
  {
    "idx_id": 9,
    "vn": "vai",
    "en": "shoulder",
    "tw": "肩膀",
    "cn": "肩膀",
    "pinin": "jiān bǎng"
  },
  {
    "idx_id": 9,
    "vn": "ngực",
    "en": "chest",
    "tw": "胸部",
    "cn": "胸部",
    "pinin": "xiōng bù"
  },
  {
    "idx_id": 9,
    "vn": "bụng",
    "en": "belly",
    "tw": "肚子",
    "cn": "肚子",
    "pinin": "dǔ zǐ"
  },
  {
    "idx_id": 9,
    "vn": "eo",
    "en": "waist",
    "tw": "腰",
    "cn": "腰",
    "pinin": "yāo"
  },
  {
    "idx_id": 9,
    "vn": "lưng",
    "en": "back",
    "tw": "背",
    "cn": "背",
    "pinin": "bèi"
  },
  {
    "idx_id": 9,
    "vn": "mông",
    "en": "butt",
    "tw": "屁股",
    "cn": "屁股",
    "pinin": "pì gǔ"
  },
  {
    "idx_id": 9,
    "vn": "tay",
    "en": "hand",
    "tw": "手",
    "cn": "手",
    "pinin": "shǒu"
  },
  {
    "idx_id": 9,
    "vn": "cổ tay",
    "en": "wrist",
    "tw": "手腕",
    "cn": "手腕",
    "pinin": "shǒu wàn"
  },
  {
    "idx_id": 9,
    "vn": "chân",
    "en": "foot",
    "tw": "腳",
    "cn": "脚",
    "pinin": "jiǎo"
  },
  {
    "idx_id": 9,
    "vn": "đầu gối",
    "en": "knee",
    "tw": "膝蓋",
    "cn": "膝盖",
    "pinin": "xī gài"
  },
  {
    "idx_id": 10,
    "vn": "mắt",
    "en": "eye",
    "tw": "眼",
    "cn": "眼",
    "pinin": "yǎn"
  },
  {
    "idx_id": 10,
    "vn": "tai",
    "en": "ear",
    "tw": "耳",
    "cn": "耳",
    "pinin": "ěr"
  },
  {
    "idx_id": 10,
    "vn": "mũi",
    "en": "nose",
    "tw": "鼻",
    "cn": "鼻",
    "pinin": "bí"
  },
  {
    "idx_id": 10,
    "vn": "miệng",
    "en": "mouth",
    "tw": "嘴",
    "cn": "嘴",
    "pinin": "zuǐ"
  },
  {
    "idx_id": 10,
    "vn": "trán",
    "en": "forehead",
    "tw": "額頭",
    "cn": "额头",
    "pinin": "é tóu"
  },
  {
    "idx_id": 10,
    "vn": "lông mày",
    "en": "eyebrow",
    "tw": "眉毛",
    "cn": "眉毛",
    "pinin": "méi máo"
  },
  {
    "idx_id": 10,
    "vn": "lông mi",
    "en": "eyelashes",
    "tw": "睫毛",
    "cn": "睫毛",
    "pinin": "jié máo"
  },
  {
    "idx_id": 10,
    "vn": "má",
    "en": "cheek",
    "tw": "臉頰",
    "cn": "脸颊",
    "pinin": "liǎn jiá"
  },
  {
    "idx_id": 10,
    "vn": "cằm",
    "en": "chin",
    "tw": "下巴",
    "cn": "下巴",
    "pinin": "xià bā"
  },
  {
    "idx_id": 10,
    "vn": "hàm",
    "en": "jaw",
    "tw": "顎",
    "cn": "颚",
    "pinin": "è"
  },
  {
    "idx_id": 10,
    "vn": "nhân trung",
    "en": "philtrum",
    "tw": "人中",
    "cn": "人中",
    "pinin": "rén zhōng"
  },
  {
    "idx_id": 10,
    "vn": "ấn đường",
    "en": "between the eyebrows",
    "tw": "眉心",
    "cn": "眉心",
    "pinin": "méi xīn"
  },
  {
    "idx_id": 11,
    "vn": "móng tay",
    "en": "nail",
    "tw": "指甲",
    "cn": "指甲",
    "pinin": "zhǐ jiǎ"
  },
  {
    "idx_id": 11,
    "vn": "nắm tay",
    "en": "fist",
    "tw": "拳頭",
    "cn": "拳头",
    "pinin": "quán tou"
  },
  {
    "idx_id": 11,
    "vn": "ngón cái",
    "en": "thumb",
    "tw": "拇指",
    "cn": "拇指",
    "pinin": "mǔ zhǐ"
  },
  {
    "idx_id": 11,
    "vn": "ngón trỏ",
    "en": "index finger",
    "tw": "食指",
    "cn": "食指",
    "pinin": "shí zhǐ"
  },
  {
    "idx_id": 11,
    "vn": "ngón giữa",
    "en": "middle finger",
    "tw": "中指",
    "cn": "中指",
    "pinin": "zhōng zhǐ"
  },
  {
    "idx_id": 11,
    "vn": "ngón vô danh",
    "en": "ring finger",
    "tw": "無名指",
    "cn": "无名指",
    "pinin": "wú míng zhǐ"
  },
  {
    "idx_id": 11,
    "vn": "ngón út",
    "en": "little finger",
    "tw": "小指",
    "cn": "小指",
    "pinin": "xiǎo zhǐ"
  },
  {
    "idx_id": 11,
    "vn": "lòng bàn tay",
    "en": "palm",
    "tw": "掌心",
    "cn": "掌心",
    "pinin": "zhǎng xīn"
  },
  {
    "idx_id": 11,
    "vn": "khuỷu tay",
    "en": "elbow",
    "tw": "肘",
    "cn": "肘",
    "pinin": "zhǒu"
  },
  {
    "idx_id": 11,
    "vn": "cổ tay",
    "en": "wrist",
    "tw": "手腕",
    "cn": "手腕",
    "pinin": "shǒu wàn"
  },
  {
    "idx_id": 11,
    "vn": "cẳng tay",
    "en": "forearm",
    "tw": "前臂",
    "cn": "前臂",
    "pinin": "qián bì"
  },
  {
    "idx_id": 11,
    "vn": "cánh tay",
    "en": "upper arm",
    "tw": "上臂",
    "cn": "上臂",
    "pinin": "shàng bì"
  },
  {
    "idx_id": 12,
    "vn": "bắp đùi",
    "en": "thigh",
    "tw": "大腿",
    "cn": "大腿",
    "pinin": "dà tuǐ"
  },
  {
    "idx_id": 12,
    "vn": "bắp chân",
    "en": "calf",
    "tw": "小腿",
    "cn": "小腿",
    "pinin": "xiǎo tuǐ"
  },
  {
    "idx_id": 12,
    "vn": "đầu gối",
    "en": "knee",
    "tw": "膝蓋",
    "cn": "膝盖",
    "pinin": "xī gài"
  },
  {
    "idx_id": 12,
    "vn": "lông chân",
    "en": "foot hair",
    "tw": "腳毛",
    "cn": "脚毛",
    "pinin": "jiǎo máo"
  },
  {
    "idx_id": 12,
    "vn": "bàn chân",
    "en": "foot",
    "tw": "腳掌",
    "cn": "脚掌",
    "pinin": "jiǎo zhǎng"
  },
  {
    "idx_id": 12,
    "vn": "mắt cá",
    "en": "ankle",
    "tw": "腳踝",
    "cn": "脚踝",
    "pinin": "jiǎo huái"
  },
  {
    "idx_id": 12,
    "vn": "ngón chân",
    "en": "toe",
    "tw": "腳趾",
    "cn": "脚趾",
    "pinin": "jiǎo zhǐ"
  },
  {
    "idx_id": 12,
    "vn": "móng chân",
    "en": "toenail",
    "tw": "腳趾甲",
    "cn": "脚趾甲",
    "pinin": "jiǎo zhǐ jiǎ"
  },
  {
    "idx_id": 12,
    "vn": "gót chân",
    "en": "heel",
    "tw": "腳跟",
    "cn": "脚跟",
    "pinin": "jiǎo gēn"
  },
  {
    "idx_id": 12,
    "vn": "mu bàn chân",
    "en": "instep",
    "tw": "腳背",
    "cn": "脚背",
    "pinin": "jiǎo bèi"
  },
  {
    "idx_id": 12,
    "vn": "lòng bàn chân",
    "en": "sole",
    "tw": "腳底",
    "cn": "脚底",
    "pinin": "jiǎo dǐ"
  },
  {
    "idx_id": 12,
    "vn": "dấu chân",
    "en": "footprint",
    "tw": "腳印",
    "cn": "脚印",
    "pinin": "jiǎo yìn"
  },
  {
    "idx_id": 13,
    "vn": "tiền giấy",
    "en": "banknote",
    "tw": "紙幣",
    "cn": "纸币",
    "pinin": "zhǐ bì"
  },
  {
    "idx_id": 13,
    "vn": "tiền xu",
    "en": "coin",
    "tw": "硬幣",
    "cn": "硬币",
    "pinin": "yìng bì"
  },
  {
    "idx_id": 13,
    "vn": "séc",
    "en": "a check",
    "tw": "支票",
    "cn": "支票",
    "pinin": "zhī piào"
  },
  {
    "idx_id": 13,
    "vn": "học phí",
    "en": "tuition",
    "tw": "學費",
    "cn": "学费",
    "pinin": "xué fèi"
  },
  {
    "idx_id": 13,
    "vn": "bưu phí",
    "en": "postage",
    "tw": "郵資",
    "cn": "邮资",
    "pinin": "yóu zī"
  },
  {
    "idx_id": 13,
    "vn": "phí vận chuyển",
    "en": "freight",
    "tw": "運費",
    "cn": "运费",
    "pinin": "yùn fèi"
  },
  {
    "idx_id": 13,
    "vn": "giá vé",
    "en": "ticket price",
    "tw": "票價",
    "cn": "票价",
    "pinin": "piào jià"
  },
  {
    "idx_id": 13,
    "vn": "tiền thuê",
    "en": "a rental",
    "tw": "租金",
    "cn": "租金",
    "pinin": "zū jīn"
  },
  {
    "idx_id": 13,
    "vn": "tiền thuế",
    "en": "tax",
    "tw": "稅金",
    "cn": "税金",
    "pinin": "shuì jīn"
  },
  {
    "idx_id": 13,
    "vn": "tiền chẵn",
    "en": "large denomination",
    "tw": "大面值貨幣",
    "cn": "大面值货币",
    "pinin": "dà miàn zhí huò bì"
  },
  {
    "idx_id": 13,
    "vn": "tiền lẻ",
    "en": "small change",
    "tw": "零金",
    "cn": "零金",
    "pinin": "líng jīn"
  },
  {
    "idx_id": 13,
    "vn": "tiền gửi",
    "en": "a bank deposit",
    "tw": "存款",
    "cn": "存款",
    "pinin": "cún kuǎn"
  },
  {
    "idx_id": 14,
    "vn": "phòng khách",
    "en": "living room",
    "tw": "客廳",
    "cn": "客厅",
    "pinin": "kè tīng"
  },
  {
    "idx_id": 14,
    "vn": "phòng bếp",
    "en": "kitchen",
    "tw": "廚房",
    "cn": "厨房",
    "pinin": "chú fáng"
  },
  {
    "idx_id": 14,
    "vn": "phòng ăn",
    "en": "dining room",
    "tw": "飯廳",
    "cn": "饭厅",
    "pinin": "fàn tīng"
  },
  {
    "idx_id": 14,
    "vn": "phòng ngủ",
    "en": "bedroom",
    "tw": "臥室",
    "cn": "卧室",
    "pinin": "wò shì"
  },
  {
    "idx_id": 14,
    "vn": "phòng làm việc",
    "en": "working room",
    "tw": "工作室",
    "cn": "工作室",
    "pinin": "gōng zuò shì"
  },
  {
    "idx_id": 14,
    "vn": "phòng tắm",
    "en": "bathroom",
    "tw": "浴室",
    "cn": "浴室",
    "pinin": "yù shì"
  },
  {
    "idx_id": 14,
    "vn": "phòng thờ",
    "en": "worship room",
    "tw": "祭祀房",
    "cn": "祭祀房",
    "pinin": "jì sì fáng"
  },
  {
    "idx_id": 14,
    "vn": "ban công",
    "en": "balcony",
    "tw": "陽台",
    "cn": "阳台",
    "pinin": "yáng tái"
  },
  {
    "idx_id": 14,
    "vn": "biệt thự",
    "en": "villa",
    "tw": "別墅",
    "cn": "别墅",
    "pinin": "bié shù"
  },
  {
    "idx_id": 14,
    "vn": "chung cư",
    "en": "apartment building",
    "tw": "公寓",
    "cn": "公寓",
    "pinin": "gōng yù"
  },
  {
    "idx_id": 14,
    "vn": "vườn",
    "en": "garden",
    "tw": "花園",
    "cn": "花园",
    "pinin": "huā yuán"
  },
  {
    "idx_id": 14,
    "vn": "sân",
    "en": "the yard",
    "tw": "庭院",
    "cn": "庭院",
    "pinin": "tíng yuàn"
  },
  {
    "idx_id": 15,
    "vn": "ho",
    "en": "to cough",
    "tw": "咳嗽",
    "cn": "咳嗽",
    "pinin": "ké sòu"
  },
  {
    "idx_id": 15,
    "vn": "sốt",
    "en": "fever",
    "tw": "發燒",
    "cn": "发烧",
    "pinin": "fā shāo"
  },
  {
    "idx_id": 15,
    "vn": "ngạt mũi",
    "en": "stuffy",
    "tw": "鼻塞",
    "cn": "鼻塞",
    "pinin": "bí sāi"
  },
  {
    "idx_id": 15,
    "vn": "sổ mũi",
    "en": "to have a running nose",
    "tw": "流鼻涕",
    "cn": "流鼻涕",
    "pinin": "liú bí tì"
  },
  {
    "idx_id": 15,
    "vn": "đau đầu",
    "en": "headache",
    "tw": "頭痛",
    "cn": "头痛",
    "pinin": "tóu tòng"
  },
  {
    "idx_id": 15,
    "vn": "viêm họng",
    "en": "sore throat",
    "tw": "喉嚨痛",
    "cn": "喉咙痛",
    "pinin": "hóu lóng tòng"
  },
  {
    "idx_id": 15,
    "vn": "đau răng",
    "en": "toothache",
    "tw": "牙疼",
    "cn": "牙疼",
    "pinin": "yá téng"
  },
  {
    "idx_id": 15,
    "vn": "hắt hơi",
    "en": "to sneeze",
    "tw": "打噴嚏",
    "cn": "打喷嚏",
    "pinin": "dǎ pēn tì"
  },
  {
    "idx_id": 15,
    "vn": "mất ngủ",
    "en": "to be insomniac",
    "tw": "失眠",
    "cn": "失眠",
    "pinin": "shī mián"
  },
  {
    "idx_id": 15,
    "vn": "đau bụng",
    "en": "stomachache",
    "tw": "腹痛",
    "cn": "腹痛",
    "pinin": "fù tòng"
  },
  {
    "idx_id": 15,
    "vn": "nôn",
    "en": "throw up",
    "tw": "嘔吐",
    "cn": "呕吐",
    "pinin": "ǒu tù"
  },
  {
    "idx_id": 15,
    "vn": "chóng mặt",
    "en": "dizzy",
    "tw": "頭暈",
    "cn": "头晕",
    "pinin": "tóu yūn"
  },
  {
    "idx_id": 16,
    "vn": "đông",
    "en": "east",
    "tw": "東",
    "cn": "东",
    "pinin": "dōng"
  },
  {
    "idx_id": 16,
    "vn": "nam",
    "en": "south",
    "tw": "南",
    "cn": "南",
    "pinin": "nán"
  },
  {
    "idx_id": 16,
    "vn": "tây",
    "en": "west",
    "tw": "西",
    "cn": "西",
    "pinin": "xī"
  },
  {
    "idx_id": 16,
    "vn": "bắc",
    "en": "north",
    "tw": "北",
    "cn": "北",
    "pinin": "běi"
  },
  {
    "idx_id": 16,
    "vn": "phía trên",
    "en": "above",
    "tw": "上面",
    "cn": "上面",
    "pinin": "shàng miàn"
  },
  {
    "idx_id": 16,
    "vn": "phía dưới",
    "en": "below",
    "tw": "下面",
    "cn": "下面",
    "pinin": "xià miàn"
  },
  {
    "idx_id": 16,
    "vn": "bên trái",
    "en": "left",
    "tw": "左邊",
    "cn": "左边",
    "pinin": "zuǒ biān"
  },
  {
    "idx_id": 16,
    "vn": "bên phải",
    "en": "right",
    "tw": "右邊",
    "cn": "右边",
    "pinin": "yòu biān"
  },
  {
    "idx_id": 16,
    "vn": "phía trước",
    "en": "front",
    "tw": "前面",
    "cn": "前面",
    "pinin": "qián miàn"
  },
  {
    "idx_id": 16,
    "vn": "phía sau",
    "en": "behind",
    "tw": "後面",
    "cn": "后面",
    "pinin": "hòu miàn"
  },
  {
    "idx_id": 16,
    "vn": "bên ngoài",
    "en": "outside",
    "tw": "外面",
    "cn": "外面",
    "pinin": "wài miàn"
  },
  {
    "idx_id": 16,
    "vn": "bên trong",
    "en": "inside",
    "tw": "裡面",
    "cn": "里面",
    "pinin": "lǐ miàn"
  },
  {
    "idx_id": 17,
    "vn": "mặt trời",
    "en": "sun",
    "tw": "太陽",
    "cn": "太阳",
    "pinin": "tài yáng"
  },
  {
    "idx_id": 17,
    "vn": "gió",
    "en": "wind",
    "tw": "風",
    "cn": "风",
    "pinin": "fēng"
  },
  {
    "idx_id": 17,
    "vn": "tuyết",
    "en": "snow",
    "tw": "雪",
    "cn": "雪",
    "pinin": "xuě"
  },
  {
    "idx_id": 17,
    "vn": "mây",
    "en": "cloud",
    "tw": "雲",
    "cn": "云",
    "pinin": "yún"
  },
  {
    "idx_id": 17,
    "vn": "sét",
    "en": "lightning",
    "tw": "閃電",
    "cn": "闪电",
    "pinin": "shǎn diàn"
  },
  {
    "idx_id": 17,
    "vn": "mưa",
    "en": "rain",
    "tw": "雨",
    "cn": "雨",
    "pinin": "yǔ"
  },
  {
    "idx_id": 17,
    "vn": "mưa phùn",
    "en": "drizzle",
    "tw": "毛毛雨",
    "cn": "毛毛雨",
    "pinin": "máo máo yǔ"
  },
  {
    "idx_id": 17,
    "vn": "cầu vồng",
    "en": "rainbow",
    "tw": "彩虹",
    "cn": "彩虹",
    "pinin": "cǎi hóng"
  },
  {
    "idx_id": 17,
    "vn": "sương mù",
    "en": "fog",
    "tw": "霧",
    "cn": "雾",
    "pinin": "wù"
  },
  {
    "idx_id": 17,
    "vn": "bão",
    "en": "storm",
    "tw": "風暴",
    "cn": "风暴",
    "pinin": "fēng bào"
  },
  {
    "idx_id": 17,
    "vn": "lốc xoáy",
    "en": "tornado",
    "tw": "龍捲風",
    "cn": "龙卷风",
    "pinin": "lóng juǎn fēng"
  },
  {
    "idx_id": 17,
    "vn": "bão tuyết lớn",
    "en": "blizzard",
    "tw": "暴風雪",
    "cn": "暴风雪",
    "pinin": "bào fēng xuě"
  },
  {
    "idx_id": 18,
    "vn": "Ngôn ngữ",
    "en": "Language",
    "tw": "語言",
    "cn": "语言",
    "pinin": "yǔ yán"
  },
  {
    "idx_id": 18,
    "vn": "Toán học",
    "en": "Mathematics",
    "tw": "數學",
    "cn": "数学",
    "pinin": "shù xué"
  },
  {
    "idx_id": 18,
    "vn": "Tự nhiên",
    "en": "Natural",
    "tw": "自然",
    "cn": "自然",
    "pinin": "zì rán"
  },
  {
    "idx_id": 18,
    "vn": "Địa lý",
    "en": "Geography",
    "tw": "地理",
    "cn": "地理",
    "pinin": "dì lǐ"
  },
  {
    "idx_id": 18,
    "vn": "Hóa học",
    "en": "Chemistry",
    "tw": "化學",
    "cn": "化学",
    "pinin": "huà xué"
  },
  {
    "idx_id": 18,
    "vn": "Sinh học",
    "en": "Biology",
    "tw": "生物",
    "cn": "生物",
    "pinin": "shēng wù"
  },
  {
    "idx_id": 18,
    "vn": "Âm nhạc",
    "en": "Music",
    "tw": "音樂",
    "cn": "音乐",
    "pinin": "yīn yuè"
  },
  {
    "idx_id": 18,
    "vn": "Mỹ thuật",
    "en": "Art",
    "tw": "美術",
    "cn": "美术",
    "pinin": "měi shù"
  },
  {
    "idx_id": 18,
    "vn": "Lịch sử",
    "en": "History",
    "tw": "歷史",
    "cn": "历史",
    "pinin": "lì shǐ"
  },
  {
    "idx_id": 18,
    "vn": "Thể thao",
    "en": "Physical Education",
    "tw": "體育",
    "cn": "体育",
    "pinin": "tǐ yù"
  },
  {
    "idx_id": 18,
    "vn": "Triết học",
    "en": "Philosophy",
    "tw": "哲學",
    "cn": "哲学",
    "pinin": "zhé xué"
  },
  {
    "idx_id": 18,
    "vn": "Xã hội",
    "en": "Society",
    "tw": "社會",
    "cn": "社会",
    "pinin": "shè huì"
  },
  {
    "idx_id": 19,
    "vn": "bưu điện",
    "en": "post office",
    "tw": "郵局",
    "cn": "邮局",
    "pinin": "yóu jú"
  },
  {
    "idx_id": 19,
    "vn": "người đưa thư",
    "en": "postman",
    "tw": "郵差",
    "cn": "邮差",
    "pinin": "yóu chāi"
  },
  {
    "idx_id": 19,
    "vn": "tem",
    "en": "stamp",
    "tw": "郵票",
    "cn": "邮票",
    "pinin": "yóu piào"
  },
  {
    "idx_id": 19,
    "vn": "dấu bưu điện",
    "en": "postmark",
    "tw": "郵戳",
    "cn": "邮戳",
    "pinin": "yóu chuō"
  },
  {
    "idx_id": 19,
    "vn": "mã bưu chính",
    "en": "postal code",
    "tw": "郵政編碼",
    "cn": "邮政编码",
    "pinin": "yóu zhèng biān mǎ"
  },
  {
    "idx_id": 19,
    "vn": "hộp thư",
    "en": "postbox",
    "tw": "郵筒",
    "cn": "邮筒",
    "pinin": "yóu tǒng"
  },
  {
    "idx_id": 19,
    "vn": "phong bì",
    "en": "envelope",
    "tw": "信封",
    "cn": "信封",
    "pinin": "xìn fēng"
  },
  {
    "idx_id": 19,
    "vn": "giấy thư",
    "en": "letter",
    "tw": "信紙",
    "cn": "信纸",
    "pinin": "xìn zhǐ"
  },
  {
    "idx_id": 19,
    "vn": "bưu thiếp",
    "en": "postcard",
    "tw": "名信片",
    "cn": "名信片",
    "pinin": "míng xìn piàn"
  },
  {
    "idx_id": 19,
    "vn": "bưu phẩm",
    "en": "package",
    "tw": "包裹",
    "cn": "包裹",
    "pinin": "bāo guǒ"
  },
  {
    "idx_id": 19,
    "vn": "gửi thư",
    "en": "send a letter",
    "tw": "寄信",
    "cn": "寄信",
    "pinin": "jì xìn"
  },
  {
    "idx_id": 19,
    "vn": "sưu tập tem",
    "en": "stamp collecting",
    "tw": "集郵",
    "cn": "集邮",
    "pinin": "jí yóu"
  },
  {
    "idx_id": 20,
    "vn": "gương",
    "en": "mirror",
    "tw": "鏡子",
    "cn": "镜子",
    "pinin": "jìng zǐ"
  },
  {
    "idx_id": 20,
    "vn": "bồn rửa",
    "en": "sink",
    "tw": "盥洗盆",
    "cn": "盥洗盆",
    "pinin": "guàn xǐ pén"
  },
  {
    "idx_id": 20,
    "vn": "vòi",
    "en": "faucet",
    "tw": "水龍頭",
    "cn": "水龙头",
    "pinin": "shuǐ lóng tóu"
  },
  {
    "idx_id": 20,
    "vn": "khăn mặt",
    "en": "face towel",
    "tw": "洗臉毛巾",
    "cn": "洗脸毛巾",
    "pinin": "xǐ liǎn máo jīn"
  },
  {
    "idx_id": 20,
    "vn": "bàn chải đánh răng",
    "en": "toothbrush",
    "tw": "牙刷",
    "cn": "牙刷",
    "pinin": "yá shuā"
  },
  {
    "idx_id": 20,
    "vn": "kem đánh răng",
    "en": "toothpaste",
    "tw": "牙膏",
    "cn": "牙膏",
    "pinin": "yá gāo"
  },
  {
    "idx_id": 20,
    "vn": "lược",
    "en": "comb",
    "tw": "梳子",
    "cn": "梳子",
    "pinin": "shū zǐ"
  },
  {
    "idx_id": 20,
    "vn": "nước súc miệng",
    "en": "mouthwash",
    "tw": "漱口水",
    "cn": "漱口水",
    "pinin": "shù kǒu shuǐ"
  },
  {
    "idx_id": 20,
    "vn": "dao cạo râu",
    "en": "razor",
    "tw": "刮鬍刀",
    "cn": "刮胡刀",
    "pinin": "guā hú dāo"
  },
  {
    "idx_id": 20,
    "vn": "bọt cạo râu",
    "en": "shaving foam",
    "tw": "刮鬍泡",
    "cn": "刮胡泡",
    "pinin": "guā hú pào"
  },
  {
    "idx_id": 20,
    "vn": "sữa rửa mặt",
    "en": "facial cleanser",
    "tw": "洗面乳",
    "cn": "洗面乳",
    "pinin": "xǐ miàn rǔ"
  },
  {
    "idx_id": 20,
    "vn": "xà phòng",
    "en": "soap",
    "tw": "肥皂",
    "cn": "肥皂",
    "pinin": "féi zào"
  },
  {
    "idx_id": 21,
    "vn": "dãy núi",
    "en": "mountain range",
    "tw": "山脈",
    "cn": "山脉",
    "pinin": "shān mài"
  },
  {
    "idx_id": 21,
    "vn": "cao nguyên",
    "en": "plateau",
    "tw": "高原",
    "cn": "高原",
    "pinin": "gāo yuán"
  },
  {
    "idx_id": 21,
    "vn": "đồng bằng",
    "en": "plain",
    "tw": "平原",
    "cn": "平原",
    "pinin": "píng yuán"
  },
  {
    "idx_id": 21,
    "vn": "hồ",
    "en": "lake",
    "tw": "湖泊",
    "cn": "湖泊",
    "pinin": "hú pō"
  },
  {
    "idx_id": 21,
    "vn": "sông",
    "en": "river",
    "tw": "河",
    "cn": "河",
    "pinin": "hé"
  },
  {
    "idx_id": 21,
    "vn": "rừng",
    "en": "forest",
    "tw": "森林",
    "cn": "森林",
    "pinin": "sēn lín"
  },
  {
    "idx_id": 21,
    "vn": "sa mạc",
    "en": "desert",
    "tw": "沙漠",
    "cn": "沙漠",
    "pinin": "shā mò"
  },
  {
    "idx_id": 21,
    "vn": "biển",
    "en": "sea",
    "tw": "海",
    "cn": "海",
    "pinin": "hǎi"
  },
  {
    "idx_id": 21,
    "vn": "đảo",
    "en": "island",
    "tw": "島",
    "cn": "岛",
    "pinin": "dǎo"
  },
  {
    "idx_id": 21,
    "vn": "hang động",
    "en": "cave",
    "tw": "山洞",
    "cn": "山洞",
    "pinin": "shān dòng"
  },
  {
    "idx_id": 21,
    "vn": "thị trấn",
    "en": "town",
    "tw": "城鎮",
    "cn": "城镇",
    "pinin": "chéng zhèn"
  },
  {
    "idx_id": 21,
    "vn": "cầu",
    "en": "bridge",
    "tw": "橋",
    "cn": "桥",
    "pinin": "qiáo"
  },
  {
    "idx_id": 22,
    "vn": "bóng chày",
    "en": "baseball",
    "tw": "棒球",
    "cn": "棒球",
    "pinin": "bàng qiú"
  },
  {
    "idx_id": 22,
    "vn": "bóng rổ",
    "en": "basketball",
    "tw": "籃球",
    "cn": "篮球",
    "pinin": "lán qiú"
  },
  {
    "idx_id": 22,
    "vn": "bóng bầu dục",
    "en": "rugby",
    "tw": "橄欖球",
    "cn": "橄榄球",
    "pinin": "gǎn lǎn qiú"
  },
  {
    "idx_id": 22,
    "vn": "bóng đá",
    "en": "soccer",
    "tw": "足球",
    "cn": "足球",
    "pinin": "zú qiú"
  },
  {
    "idx_id": 22,
    "vn": "bóng bàn",
    "en": "table tennis",
    "tw": "桌球",
    "cn": "桌球",
    "pinin": "zhuō qiú"
  },
  {
    "idx_id": 22,
    "vn": "bóng chuyền",
    "en": "volleyball",
    "tw": "排球",
    "cn": "排球",
    "pinin": "pái qiú"
  },
  {
    "idx_id": 22,
    "vn": "cầu lông",
    "en": "badminton",
    "tw": "羽毛球",
    "cn": "羽毛球",
    "pinin": "yǔ máo qiú"
  },
  {
    "idx_id": 22,
    "vn": "quần vợt",
    "en": "tennis",
    "tw": "網球",
    "cn": "网球",
    "pinin": "wǎng qiú"
  },
  {
    "idx_id": 22,
    "vn": "golf",
    "en": "golf",
    "tw": "高爾夫球",
    "cn": "高尔夫球",
    "pinin": "gāo ěr fū qiú"
  },
  {
    "idx_id": 22,
    "vn": "bowling",
    "en": "bowling",
    "tw": "保齡球",
    "cn": "保龄球",
    "pinin": "bǎo líng qiú"
  },
  {
    "idx_id": 22,
    "vn": "khúc côn cầu",
    "en": "hockey",
    "tw": "曲棍球",
    "cn": "曲棍球",
    "pinin": "qū gùn qiú"
  },
  {
    "idx_id": 22,
    "vn": "bi-a",
    "en": "cue sports",
    "tw": "撞球",
    "cn": "撞球",
    "pinin": "zhuàng qiú"
  },
  {
    "idx_id": 23,
    "vn": "cờ vây",
    "en": "Go",
    "tw": "圍棋",
    "cn": "围棋",
    "pinin": "wéi qí"
  },
  {
    "idx_id": 23,
    "vn": "cờ tướng",
    "en": "Chinese chess",
    "tw": "中国象棋",
    "cn": "中国象棋",
    "pinin": "zhōng guó xiàng qí"
  },
  {
    "idx_id": 23,
    "vn": "cờ Shogi",
    "en": "Shogi",
    "tw": "將棋",
    "cn": "将棋",
    "pinin": "jiāng qí"
  },
  {
    "idx_id": 23,
    "vn": "cờ vua",
    "en": "Chess",
    "tw": "西洋棋",
    "cn": "西洋棋",
    "pinin": "xī yáng qí"
  },
  {
    "idx_id": 23,
    "vn": "cờ Othello",
    "en": "Reversi",
    "tw": "黑白棋",
    "cn": "黑白棋",
    "pinin": "hēi bái qí"
  },
  {
    "idx_id": 23,
    "vn": "mạt chược",
    "en": "Mahjong",
    "tw": "麻將",
    "cn": "麻将",
    "pinin": "má jiāng"
  },
  {
    "idx_id": 23,
    "vn": "cờ nhảy",
    "en": "Chinese checkers",
    "tw": "中國跳棋",
    "cn": "中国跳棋",
    "pinin": "zhōng guó tiào qí"
  },
  {
    "idx_id": 23,
    "vn": "cờ Tic-tac-toe",
    "en": "Tic-tac-toe",
    "tw": "井字遊戲",
    "cn": "井字游戏",
    "pinin": "jǐng zì yóu xì"
  },
  {
    "idx_id": 23,
    "vn": "cờ ca-rô",
    "en": "Gomoku",
    "tw": "五子棋",
    "cn": "五子棋",
    "pinin": "wǔ zǐ qí"
  },
  {
    "idx_id": 23,
    "vn": "xì tố",
    "en": "Poker",
    "tw": "撲克",
    "cn": "扑克",
    "pinin": "pū kè"
  },
  {
    "idx_id": 23,
    "vn": "cờ triệu phú",
    "en": "Monopoly",
    "tw": "大富翁",
    "cn": "大富翁",
    "pinin": "dà fù wēng"
  },
  {
    "idx_id": 23,
    "vn": "cờ người",
    "en": "Human chess",
    "tw": "人類象棋",
    "cn": "人类象棋",
    "pinin": "rén lèi xiàng qí"
  },
  {
    "idx_id": 24,
    "vn": "lều",
    "en": "tent",
    "tw": "帳篷",
    "cn": "帐篷",
    "pinin": "zhàng péng"
  },
  {
    "idx_id": 24,
    "vn": "dây thừng",
    "en": "rope",
    "tw": "繩子",
    "cn": "绳子",
    "pinin": "shéng zǐ"
  },
  {
    "idx_id": 24,
    "vn": "lửa trại",
    "en": "campfire",
    "tw": "營火",
    "cn": "营火",
    "pinin": "yíng huǒ"
  },
  {
    "idx_id": 24,
    "vn": "la bàn",
    "en": "compass",
    "tw": "羅盤",
    "cn": "罗盘",
    "pinin": "luó pán"
  },
  {
    "idx_id": 24,
    "vn": "bản đồ",
    "en": "map",
    "tw": "地圖",
    "cn": "地图",
    "pinin": "dì tú"
  },
  {
    "idx_id": 24,
    "vn": "đèn pin",
    "en": "flashlight",
    "tw": "手電筒",
    "cn": "手电筒",
    "pinin": "shǒu diàn tǒng"
  },
  {
    "idx_id": 24,
    "vn": "túi ngủ",
    "en": "sleeping bag",
    "tw": "睡袋",
    "cn": "睡袋",
    "pinin": "shuì dài"
  },
  {
    "idx_id": 24,
    "vn": "võng",
    "en": "hammock",
    "tw": "吊床",
    "cn": "吊床",
    "pinin": "diào chuáng"
  },
  {
    "idx_id": 24,
    "vn": "rìu",
    "en": "ax",
    "tw": "斧頭",
    "cn": "斧头",
    "pinin": "fǔ tóu"
  },
  {
    "idx_id": 24,
    "vn": "củi",
    "en": "firewood",
    "tw": "木柴",
    "cn": "木柴",
    "pinin": "mù chái"
  },
  {
    "idx_id": 24,
    "vn": "diêm",
    "en": "match",
    "tw": "火柴",
    "cn": "火柴",
    "pinin": "huǒ chái"
  },
  {
    "idx_id": 24,
    "vn": "cần câu",
    "en": "fishing rod",
    "tw": "釣竿",
    "cn": "钓竿",
    "pinin": "diào gān"
  },
  {
    "idx_id": 25,
    "vn": "gió",
    "en": "wind",
    "tw": "風",
    "cn": "风",
    "pinin": "fēng"
  },
  {
    "idx_id": 25,
    "vn": "lửa",
    "en": "fire",
    "tw": "火",
    "cn": "火",
    "pinin": "huǒ"
  },
  {
    "idx_id": 25,
    "vn": "nước",
    "en": "water",
    "tw": "水",
    "cn": "水",
    "pinin": "shuǐ"
  },
  {
    "idx_id": 25,
    "vn": "đất",
    "en": "earth",
    "tw": "土",
    "cn": "土",
    "pinin": "tǔ"
  },
  {
    "idx_id": 25,
    "vn": "gỗ",
    "en": "wood",
    "tw": "木",
    "cn": "木",
    "pinin": "mù"
  },
  {
    "idx_id": 25,
    "vn": "tia sét",
    "en": "lightning",
    "tw": "雷",
    "cn": "雷",
    "pinin": "léi"
  },
  {
    "idx_id": 25,
    "vn": "băng",
    "en": "ice",
    "tw": "冰",
    "cn": "冰",
    "pinin": "bīng"
  },
  {
    "idx_id": 25,
    "vn": "độc",
    "en": "poison",
    "tw": "毒",
    "cn": "毒",
    "pinin": "dú"
  },
  {
    "idx_id": 25,
    "vn": "ánh sáng",
    "en": "light",
    "tw": "光",
    "cn": "光",
    "pinin": "guāng"
  },
  {
    "idx_id": 25,
    "vn": "tối",
    "en": "dark",
    "tw": "暗",
    "cn": "暗",
    "pinin": "àn"
  },
  {
    "idx_id": 25,
    "vn": "cuộc sống",
    "en": "life",
    "tw": "生命",
    "cn": "生命",
    "pinin": "shēng mìng"
  },
  {
    "idx_id": 25,
    "vn": "kim loại",
    "en": "metal",
    "tw": "金屬",
    "cn": "金属",
    "pinin": "jīn shǔ"
  },
  {
    "idx_id": 26,
    "vn": "nhiệt kế",
    "en": "clinical thermometer",
    "tw": "體溫計",
    "cn": "体温计",
    "pinin": "tǐ wēn jì"
  },
  {
    "idx_id": 26,
    "vn": "băng keo cá nhân",
    "en": "adhesive bandage",
    "tw": "OK繃",
    "cn": "OK绷",
    "pinin": "OK bēng"
  },
  {
    "idx_id": 26,
    "vn": "khẩu trang",
    "en": "mask",
    "tw": "口罩",
    "cn": "口罩",
    "pinin": "kǒu zhào"
  },
  {
    "idx_id": 26,
    "vn": "găng tay y tế",
    "en": "medical gloves",
    "tw": "醫用手套",
    "cn": "医用手套",
    "pinin": "yī yòng shǒu tào"
  },
  {
    "idx_id": 26,
    "vn": "gạc y tế",
    "en": "gauze",
    "tw": "紗布",
    "cn": "纱布",
    "pinin": "shā bù"
  },
  {
    "idx_id": 26,
    "vn": "băng y tế",
    "en": "bandage",
    "tw": "繃帶",
    "cn": "绷带",
    "pinin": "bēng dài"
  },
  {
    "idx_id": 26,
    "vn": "băng dính y tế",
    "en": "medical tape",
    "tw": "醫用膠帶",
    "cn": "医用胶带",
    "pinin": "yī yòng jiāo dài"
  },
  {
    "idx_id": 26,
    "vn": "túi treo tay",
    "en": "sling",
    "tw": "三角巾",
    "cn": "三角巾",
    "pinin": "sān jiǎo jīn"
  },
  {
    "idx_id": 26,
    "vn": "kéo",
    "en": "scissors",
    "tw": "剪刀",
    "cn": "剪刀",
    "pinin": "jiǎn dāo"
  },
  {
    "idx_id": 26,
    "vn": "nhíp",
    "en": "tweezers",
    "tw": "鑷子",
    "cn": "镊子",
    "pinin": "niè zǐ"
  },
  {
    "idx_id": 26,
    "vn": "tăm bông",
    "en": "cotton swab",
    "tw": "棉花棒",
    "cn": "棉花棒",
    "pinin": "mián huā bàng"
  },
  {
    "idx_id": 26,
    "vn": "thuốc",
    "en": "medication",
    "tw": "藥",
    "cn": "药",
    "pinin": "yào"
  },
  {
    "idx_id": 27,
    "vn": "cô dâu",
    "en": "bride",
    "tw": "新娘",
    "cn": "新娘",
    "pinin": "xīn niáng"
  },
  {
    "idx_id": 27,
    "vn": "chú rể",
    "en": "groom",
    "tw": "新郎",
    "cn": "新郎",
    "pinin": "xīn láng"
  },
  {
    "idx_id": 27,
    "vn": "phù dâu",
    "en": "bridesmaid",
    "tw": "伴娘",
    "cn": "伴娘",
    "pinin": "bàn niáng"
  },
  {
    "idx_id": 27,
    "vn": "phù rể",
    "en": "best man",
    "tw": "伴郎",
    "cn": "伴郎",
    "pinin": "bàn láng"
  },
  {
    "idx_id": 27,
    "vn": "nhẫn",
    "en": "ring",
    "tw": "戒指",
    "cn": "戒指",
    "pinin": "jiè zhǐ"
  },
  {
    "idx_id": 27,
    "vn": "thiệp cưới",
    "en": "wedding invitation",
    "tw": "喜帖",
    "cn": "喜帖",
    "pinin": "xǐ tiě"
  },
  {
    "idx_id": 27,
    "vn": "bó hoa",
    "en": "bouquet",
    "tw": "花束",
    "cn": "花束",
    "pinin": "huā shù"
  },
  {
    "idx_id": 27,
    "vn": "ảnh cưới",
    "en": "wedding photos",
    "tw": "婚紗照",
    "cn": "婚纱照",
    "pinin": "hūn shā zhào"
  },
  {
    "idx_id": 27,
    "vn": "bánh ngọt",
    "en": "cake",
    "tw": "蛋糕",
    "cn": "蛋糕",
    "pinin": "dàn gāo"
  },
  {
    "idx_id": 27,
    "vn": "hội trường",
    "en": "wedding hall",
    "tw": "會場",
    "cn": "会场",
    "pinin": "huì chǎng"
  },
  {
    "idx_id": 27,
    "vn": "tuần trăng mật",
    "en": "honeymoon",
    "tw": "蜜月",
    "cn": "蜜月",
    "pinin": "mì yuè"
  },
  {
    "idx_id": 27,
    "vn": "kết hôn",
    "en": "married",
    "tw": "結婚",
    "cn": "结婚",
    "pinin": "jié hūn"
  },
  {
    "idx_id": 28,
    "vn": "bút chì",
    "en": "pencil",
    "tw": "鉛筆",
    "cn": "铅笔",
    "pinin": "qiān bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút chì bấm",
    "en": "mechanical pencil",
    "tw": "自動鉛筆",
    "cn": "自动铅笔",
    "pinin": "zì dòng qiān bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút bi",
    "en": "ballpoint pen",
    "tw": "原子筆",
    "cn": "原子笔",
    "pinin": "yuán zǐ bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút máy",
    "en": "fountain pen",
    "tw": "鋼筆",
    "cn": "钢笔",
    "pinin": "gāng bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút lông",
    "en": "ink brush",
    "tw": "毛筆",
    "cn": "毛笔",
    "pinin": "máo bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút dạ quang",
    "en": "highlighter",
    "tw": "螢光筆",
    "cn": "萤光笔",
    "pinin": "yíng guāng bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút sáp màu",
    "en": "crayon",
    "tw": "蠟筆",
    "cn": "蜡笔",
    "pinin": "là bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút vẽ kỹ thuật",
    "en": "technical pen",
    "tw": "針筆",
    "cn": "针笔",
    "pinin": "zhēn bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút lông dầu",
    "en": "marker pen",
    "tw": "麥克筆",
    "cn": "麦克笔",
    "pinin": "mài kè bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút bảng trắng",
    "en": "whiteboard pen",
    "tw": "白板筆",
    "cn": "白板笔",
    "pinin": "bái bǎn bǐ"
  },
  {
    "idx_id": 28,
    "vn": "phấn viết bảng",
    "en": "chalk",
    "tw": "粉筆",
    "cn": "粉笔",
    "pinin": "fěn bǐ"
  },
  {
    "idx_id": 28,
    "vn": "bút xoá",
    "en": "correction fluid",
    "tw": "修正液",
    "cn": "修正液",
    "pinin": "xiū zhèng yè"
  },
  {
    "idx_id": 29,
    "vn": "Mặt Trời",
    "en": "Sun",
    "tw": "太陽",
    "cn": "太阳",
    "pinin": "tài yáng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Thủy",
    "en": "Mercury",
    "tw": "水星",
    "cn": "水星",
    "pinin": "shuǐ xīng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Kim",
    "en": "Venus",
    "tw": "金星",
    "cn": "金星",
    "pinin": "jīn xīng"
  },
  {
    "idx_id": 29,
    "vn": "Trái Đất",
    "en": "Earth",
    "tw": "地球",
    "cn": "地球",
    "pinin": "dì qiú"
  },
  {
    "idx_id": 29,
    "vn": "Sao Hỏa",
    "en": "Mars",
    "tw": "火星",
    "cn": "火星",
    "pinin": "huǒ xīng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Mộc",
    "en": "Jupiter",
    "tw": "木星",
    "cn": "木星",
    "pinin": "mù xīng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Thổ",
    "en": "Satum",
    "tw": "土星",
    "cn": "土星",
    "pinin": "tǔ xīng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Thiên Vương",
    "en": "Uranus",
    "tw": "天王星",
    "cn": "天王星",
    "pinin": "tiān wáng xīng"
  },
  {
    "idx_id": 29,
    "vn": "Sao Hải Vương",
    "en": "Neptune",
    "tw": "海王星",
    "cn": "海王星",
    "pinin": "hǎi wáng xīng"
  },
  {
    "idx_id": 29,
    "vn": "Mặt Trăng",
    "en": "Moon",
    "tw": "月球",
    "cn": "月球",
    "pinin": "yuè qiú"
  },
  {
    "idx_id": 29,
    "vn": "Sao chổi",
    "en": "Comet",
    "tw": "彗星",
    "cn": "彗星",
    "pinin": "huì xīng"
  },
  {
    "idx_id": 29,
    "vn": "Vẫn thạch",
    "en": "Meteorite",
    "tw": "隕石",
    "cn": "陨石",
    "pinin": "yǔn shí"
  },
  {
    "idx_id": 30,
    "vn": "ngọn cây",
    "en": "treetop",
    "tw": "樹梢",
    "cn": "树梢",
    "pinin": "shù shāo"
  },
  {
    "idx_id": 30,
    "vn": "thân cây",
    "en": "tree-trunk",
    "tw": "樹幹",
    "cn": "树干",
    "pinin": "shù gàn"
  },
  {
    "idx_id": 30,
    "vn": "cành cây",
    "en": "branch",
    "tw": "樹枝",
    "cn": "树枝",
    "pinin": "shù zhī"
  },
  {
    "idx_id": 30,
    "vn": "tán lá",
    "en": "leaf canopy",
    "tw": "葉冠",
    "cn": "叶冠",
    "pinin": "yè guān"
  },
  {
    "idx_id": 30,
    "vn": "rễ",
    "en": "root",
    "tw": "樹根",
    "cn": "树根",
    "pinin": "shù gēn"
  },
  {
    "idx_id": 30,
    "vn": "lõi",
    "en": "tree-core",
    "tw": "樹芯",
    "cn": "树芯",
    "pinin": "shù xīn"
  },
  {
    "idx_id": 30,
    "vn": "vòng năm",
    "en": "growth ring",
    "tw": "年輪",
    "cn": "年轮",
    "pinin": "nián lún"
  },
  {
    "idx_id": 30,
    "vn": "vỏ",
    "en": "tree bark",
    "tw": "樹皮",
    "cn": "树皮",
    "pinin": "shù pí"
  },
  {
    "idx_id": 30,
    "vn": "lá rộng",
    "en": "broad-leaved",
    "tw": "闊葉",
    "cn": "阔叶",
    "pinin": "kuò yè"
  },
  {
    "idx_id": 30,
    "vn": "lá kim",
    "en": "needle-leaved",
    "tw": "針葉",
    "cn": "针叶",
    "pinin": "zhēn yè"
  },
  {
    "idx_id": 30,
    "vn": "cành khô",
    "en": "dried branch",
    "tw": "枯枝",
    "cn": "枯枝",
    "pinin": "kū zhī"
  },
  {
    "idx_id": 30,
    "vn": "lá khô",
    "en": "dried leaf",
    "tw": "枯葉",
    "cn": "枯叶",
    "pinin": "kū yè"
  },
  {
    "idx_id": 31,
    "vn": "tế bào máu",
    "en": "blood cell",
    "tw": "血球",
    "cn": "血球",
    "pinin": "xuè qiú"
  },
  {
    "idx_id": 31,
    "vn": "hồng cầu",
    "en": "red blood cell",
    "tw": "紅血球",
    "cn": "红血球",
    "pinin": "hóng xuè qiú"
  },
  {
    "idx_id": 31,
    "vn": "bạch cầu",
    "en": "white blood cell",
    "tw": "白血球",
    "cn": "白血球",
    "pinin": "bái xuè qiú"
  },
  {
    "idx_id": 31,
    "vn": "tiểu cầu",
    "en": "platelet",
    "tw": "血小板",
    "cn": "血小板",
    "pinin": "xuè xiǎo bǎn"
  },
  {
    "idx_id": 31,
    "vn": "nhóm máu",
    "en": "blood type",
    "tw": "血型",
    "cn": "血型",
    "pinin": "xuè xíng"
  },
  {
    "idx_id": 31,
    "vn": "mạch máu",
    "en": "blood vessel",
    "tw": "血管",
    "cn": "血管",
    "pinin": "xuè guǎn"
  },
  {
    "idx_id": 31,
    "vn": "huyết áp",
    "en": "blood pressure",
    "tw": "血壓",
    "cn": "血压",
    "pinin": "xiě yā"
  },
  {
    "idx_id": 31,
    "vn": "huyết khối",
    "en": "thrombosis",
    "tw": "血栓形成",
    "cn": "血栓形成",
    "pinin": "xuè shuān xíng chéng"
  },
  {
    "idx_id": 31,
    "vn": "chảy máu",
    "en": "bleeding",
    "tw": "流血",
    "cn": "流血",
    "pinin": "liú xiě"
  },
  {
    "idx_id": 31,
    "vn": "cầm máu",
    "en": "hemostasis",
    "tw": "止血",
    "cn": "止血",
    "pinin": "zhǐ xuè"
  },
  {
    "idx_id": 31,
    "vn": "hiến máu",
    "en": "blood donation",
    "tw": "捐血",
    "cn": "捐血",
    "pinin": "juān xiě"
  },
  {
    "idx_id": 31,
    "vn": "thiếu máu",
    "en": "anemia",
    "tw": "貧血",
    "cn": "贫血",
    "pinin": "pín xiě"
  },
  {
    "idx_id": 32,
    "vn": "đỉnh núi",
    "en": "mountain peak",
    "tw": "山頂",
    "cn": "山顶",
    "pinin": "shān dǐng"
  },
  {
    "idx_id": 32,
    "vn": "sườn núi",
    "en": "mountainside",
    "tw": "山腰",
    "cn": "山腰",
    "pinin": "shān yāo"
  },
  {
    "idx_id": 32,
    "vn": "chân núi",
    "en": "the foot of a mountain",
    "tw": "山腳",
    "cn": "山脚",
    "pinin": "shān jiǎo"
  },
  {
    "idx_id": 32,
    "vn": "dãy núi",
    "en": "mountain range",
    "tw": "山脈",
    "cn": "山脉",
    "pinin": "shān mài"
  },
  {
    "idx_id": 32,
    "vn": "núi lửa",
    "en": "volcano",
    "tw": "火山",
    "cn": "火山",
    "pinin": "huǒ shān"
  },
  {
    "idx_id": 32,
    "vn": "phun trào núi lửa",
    "en": "volcanic eruption",
    "tw": "火山爆發",
    "cn": "火山爆发",
    "pinin": "huǒ shān bào fā"
  },
  {
    "idx_id": 32,
    "vn": "đất trượt",
    "en": "landslide",
    "tw": "山崩",
    "cn": "山崩",
    "pinin": "shān bēng"
  },
  {
    "idx_id": 32,
    "vn": "tuyết lở",
    "en": "avalanche",
    "tw": "雪崩",
    "cn": "雪崩",
    "pinin": "xuě bēng"
  },
  {
    "idx_id": 32,
    "vn": "độ dốc",
    "en": "slope",
    "tw": "坡度",
    "cn": "坡度",
    "pinin": "pō dù"
  },
  {
    "idx_id": 32,
    "vn": "độ cao",
    "en": "altitude",
    "tw": "海拔",
    "cn": "海拔",
    "pinin": "hǎi bá"
  },
  {
    "idx_id": 32,
    "vn": "say độ cao",
    "en": "altitude sickness",
    "tw": "高山症",
    "cn": "高山症",
    "pinin": "gāo shān zhèng"
  },
  {
    "idx_id": 32,
    "vn": "Phan Xi Păng",
    "en": "Fansipan",
    "tw": "番西邦峰",
    "cn": "番西邦峰",
    "pinin": "fān xī bāng fēng"
  },
  {
    "idx_id": 33,
    "vn": "làn xe",
    "en": "lane",
    "tw": "車道",
    "cn": "车道",
    "pinin": "chē dào"
  },
  {
    "idx_id": 33,
    "vn": "vỉa hè",
    "en": "sidewalk",
    "tw": "人行道",
    "cn": "人行道",
    "pinin": "rén xíng dào"
  },
  {
    "idx_id": 33,
    "vn": "hầm chui",
    "en": "pedestrian underpass",
    "tw": "地下人行道",
    "cn": "地下人行道",
    "pinin": "dì xià rén háng dào"
  },
  {
    "idx_id": 33,
    "vn": "vòng xuyến",
    "en": "roundabout",
    "tw": "圓環",
    "cn": "圆环",
    "pinin": "yuán huán"
  },
  {
    "idx_id": 33,
    "vn": "đèn đường",
    "en": "street light",
    "tw": "街燈",
    "cn": "街灯",
    "pinin": "jiē dēng"
  },
  {
    "idx_id": 33,
    "vn": "đèn giao thông",
    "en": "traffic Light",
    "tw": "紅綠燈",
    "cn": "红绿灯",
    "pinin": "hóng lǜ dēng"
  },
  {
    "idx_id": 33,
    "vn": "biển báo giao thông",
    "en": "traffic sign",
    "tw": "道路交通標誌",
    "cn": "道路交通标志",
    "pinin": "dào lù jiāo tōng biāo zhì"
  },
  {
    "idx_id": 33,
    "vn": "đường vằn",
    "en": "zebra crossing",
    "tw": "斑馬線",
    "cn": "斑马线",
    "pinin": "bān mǎ xiàn"
  },
  {
    "idx_id": 33,
    "vn": "ngã tư",
    "en": "crossroads",
    "tw": "十字路口",
    "cn": "十字路口",
    "pinin": "shí zì lù kǒu"
  },
  {
    "idx_id": 33,
    "vn": "ngã ba",
    "en": "3 ways junction",
    "tw": "T型路口",
    "cn": "T型路口",
    "pinin": "T xíng lù kǒu"
  },
  {
    "idx_id": 33,
    "vn": "chỗ đứng tránh",
    "en": "refuge island",
    "tw": "安全島",
    "cn": "安全岛",
    "pinin": "ān quán dǎo"
  },
  {
    "idx_id": 33,
    "vn": "cầu",
    "en": "bridge",
    "tw": "橋梁",
    "cn": "桥梁",
    "pinin": "qiáo liáng"
  },
  {
    "idx_id": 34,
    "vn": "phim hành động",
    "en": "action film",
    "tw": "動作片",
    "cn": "动作片",
    "pinin": "dòng zuò piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim lãng mạn",
    "en": "romance film",
    "tw": "愛情片",
    "cn": "爱情片",
    "pinin": "ài qíng piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim hài",
    "en": "comedy film",
    "tw": "喜劇片",
    "cn": "喜剧片",
    "pinin": "xǐ jù piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim hoạt hình",
    "en": "animation",
    "tw": "動畫片",
    "cn": "动画片",
    "pinin": "dòng huà piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim tài liệu",
    "en": "documentary film",
    "tw": "記錄片",
    "cn": "记录片",
    "pinin": "jì lù piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim chiến tranh",
    "en": "war film",
    "tw": "戰爭片",
    "cn": "战争片",
    "pinin": "zhàn zhēng piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim ma",
    "en": "ghost film",
    "tw": "鬼片",
    "cn": "鬼片",
    "pinin": "guǐ piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim kinh dị",
    "en": "horror film",
    "tw": "恐怖片",
    "cn": "恐怖片",
    "pinin": "kǒng bù piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim khoa học viễn tưởng",
    "en": "science fiction film",
    "tw": "科幻片",
    "cn": "科幻片",
    "pinin": "kē huàn piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim kỳ ảo",
    "en": "fantasy film",
    "tw": "奇幻片",
    "cn": "奇幻片",
    "pinin": "qí huàn piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim ca nhạc",
    "en": "musical film",
    "tw": "歌舞片",
    "cn": "歌舞片",
    "pinin": "gē wǔ piàn"
  },
  {
    "idx_id": 34,
    "vn": "phim nghệ thuật",
    "en": "art film",
    "tw": "藝術片",
    "cn": "艺术片",
    "pinin": "yì shù piàn"
  },
  {
    "idx_id": 35,
    "vn": "giáo dục tuổi ấu thơ",
    "en": "early childhood education",
    "tw": "學前教育",
    "cn": "学前教育",
    "pinin": "xué qián jiào yù"
  },
  {
    "idx_id": 35,
    "vn": "giáo dục tiểu học",
    "en": "primary education",
    "tw": "初等教育",
    "cn": "初等教育",
    "pinin": "chū děng jiào yù"
  },
  {
    "idx_id": 35,
    "vn": "giáo dục trung học",
    "en": "secondary education",
    "tw": "中等教育",
    "cn": "中等教育",
    "pinin": "zhōng děng jiào yù"
  },
  {
    "idx_id": 35,
    "vn": "giáo dục đại học",
    "en": "higher education",
    "tw": "高等教育",
    "cn": "高等教育",
    "pinin": "gāo děng jiào yù"
  },
  {
    "idx_id": 35,
    "vn": "đào tạo sau đại học",
    "en": "postgraduate education",
    "tw": "學士後",
    "cn": "学士后",
    "pinin": "xué shì hòu"
  },
  {
    "idx_id": 35,
    "vn": "nhà trẻ, mầm non",
    "en": "kindergarten",
    "tw": "幼稚園",
    "cn": "幼稚园",
    "pinin": "yòu zhì yuán"
  },
  {
    "idx_id": 35,
    "vn": "trường tiểu học",
    "en": "elementary school",
    "tw": "小學",
    "cn": "小学",
    "pinin": "xiǎo xué"
  },
  {
    "idx_id": 35,
    "vn": "trường trung học cơ sở",
    "en": "junior high school",
    "tw": "初級中學",
    "cn": "初级中学",
    "pinin": "chū jí zhōng xué"
  },
  {
    "idx_id": 35,
    "vn": "trường trung học phổ thông",
    "en": "senior high school",
    "tw": "高級中學",
    "cn": "高级中学",
    "pinin": "gāo jí zhōng xué"
  },
  {
    "idx_id": 35,
    "vn": "trường cao đẳng",
    "en": "college",
    "tw": "學院",
    "cn": "学院",
    "pinin": "xué yuàn"
  },
  {
    "idx_id": 35,
    "vn": "trường đại học",
    "en": "university",
    "tw": "大學",
    "cn": "大学",
    "pinin": "dà xué"
  },
  {
    "idx_id": 35,
    "vn": "trường sau đại học",
    "en": "graduate school",
    "tw": "研究所",
    "cn": "研究所",
    "pinin": "yán jiū suǒ"
  },
  {
    "idx_id": 36,
    "vn": "hội họa",
    "en": "painting",
    "tw": "繪畫",
    "cn": "绘画",
    "pinin": "huì huà"
  },
  {
    "idx_id": 36,
    "vn": "điêu khắc",
    "en": "sculpture",
    "tw": "雕塑",
    "cn": "雕塑",
    "pinin": "diāo sù"
  },
  {
    "idx_id": 36,
    "vn": "kiến trúc",
    "en": "architecture",
    "tw": "建築",
    "cn": "建筑",
    "pinin": "jiàn zhù"
  },
  {
    "idx_id": 36,
    "vn": "âm nhạc",
    "en": "music",
    "tw": "音樂",
    "cn": "音乐",
    "pinin": "yīn lè"
  },
  {
    "idx_id": 36,
    "vn": "văn học",
    "en": "literature",
    "tw": "文學",
    "cn": "文学",
    "pinin": "wén xué"
  },
  {
    "idx_id": 36,
    "vn": "múa",
    "en": "dance",
    "tw": "舞蹈",
    "cn": "舞蹈",
    "pinin": "wǔ dǎo"
  },
  {
    "idx_id": 36,
    "vn": "kịch",
    "en": "drama",
    "tw": "戲劇",
    "cn": "戏剧",
    "pinin": "xì jù"
  },
  {
    "idx_id": 36,
    "vn": "điện ảnh",
    "en": "film",
    "tw": "電影",
    "cn": "电影",
    "pinin": "diàn yǐng"
  },
  {
    "idx_id": 36,
    "vn": "game",
    "en": "game",
    "tw": "遊戲",
    "cn": "游戏",
    "pinin": "yóu xì"
  },
  {
    "idx_id": 36,
    "vn": "tác phẩm nghệ thuật",
    "en": "work of art",
    "tw": "藝術品",
    "cn": "艺术品",
    "pinin": "yì shù pǐn"
  },
  {
    "idx_id": 36,
    "vn": "tư duy sáng tạo",
    "en": "creativity",
    "tw": "創造力",
    "cn": "创造力",
    "pinin": "chuàng zào lì"
  },
  {
    "idx_id": 36,
    "vn": "tưởng tượng",
    "en": "imagination",
    "tw": "想像力",
    "cn": "想像力",
    "pinin": "xiǎng xiàng lì"
  },
  {
    "idx_id": 37,
    "vn": "giác quan",
    "en": "sense",
    "tw": "感官",
    "cn": "感官",
    "pinin": "gǎn guān"
  },
  {
    "idx_id": 37,
    "vn": "thị giác",
    "en": "vision",
    "tw": "視覺",
    "cn": "视觉",
    "pinin": "shì jué"
  },
  {
    "idx_id": 37,
    "vn": "thính giác",
    "en": "hearing",
    "tw": "聽覺",
    "cn": "听觉",
    "pinin": "tīng jué"
  },
  {
    "idx_id": 37,
    "vn": "khứu giác",
    "en": "olfaction",
    "tw": "嗅覺",
    "cn": "嗅觉",
    "pinin": "xiù jué"
  },
  {
    "idx_id": 37,
    "vn": "vị giác",
    "en": "taste",
    "tw": "味覺",
    "cn": "味觉",
    "pinin": "wèi jué"
  },
  {
    "idx_id": 37,
    "vn": "xúc giác",
    "en": "haptic perception",
    "tw": "觸覺",
    "cn": "触觉",
    "pinin": "chù jué"
  },
  {
    "idx_id": 37,
    "vn": "tri giác",
    "en": "perception",
    "tw": "知覺",
    "cn": "知觉",
    "pinin": "zhī jué"
  },
  {
    "idx_id": 37,
    "vn": "trực giác",
    "en": "intuition",
    "tw": "直覺",
    "cn": "直觉",
    "pinin": "zhí jué"
  },
  {
    "idx_id": 37,
    "vn": "tâm trạng",
    "en": "mood",
    "tw": "心情",
    "cn": "心情",
    "pinin": "xīn qíng"
  },
  {
    "idx_id": 37,
    "vn": "cảm xúc",
    "en": "emotion",
    "tw": "情緒",
    "cn": "情绪",
    "pinin": "qíng xù"
  },
  {
    "idx_id": 37,
    "vn": "tâm trí",
    "en": "mind",
    "tw": "心智",
    "cn": "心智",
    "pinin": "xīn zhì"
  },
  {
    "idx_id": 37,
    "vn": "kích thích",
    "en": "stimulus",
    "tw": "刺激",
    "cn": "刺激",
    "pinin": "cì jī"
  },
  {
    "idx_id": 38,
    "vn": "xào",
    "en": "stir frying",
    "tw": "炒",
    "cn": "炒",
    "pinin": "chǎo"
  },
  {
    "idx_id": 38,
    "vn": "rán",
    "en": "pan frying",
    "tw": "煎",
    "cn": "煎",
    "pinin": "jiān"
  },
  {
    "idx_id": 38,
    "vn": "chiên ngập dầu",
    "en": "deep frying",
    "tw": "炸",
    "cn": "炸",
    "pinin": "zhá"
  },
  {
    "idx_id": 38,
    "vn": "luộc",
    "en": "boiling",
    "tw": "煮",
    "cn": "煮",
    "pinin": "zhǔ"
  },
  {
    "idx_id": 38,
    "vn": "hầm",
    "en": "stew",
    "tw": "燉",
    "cn": "炖",
    "pinin": "dùn"
  },
  {
    "idx_id": 38,
    "vn": "hấp",
    "en": "steaming",
    "tw": "蒸",
    "cn": "蒸",
    "pinin": "zhēng"
  },
  {
    "idx_id": 38,
    "vn": "xông khói",
    "en": "smoking",
    "tw": "燻",
    "cn": "熏",
    "pinin": "xūn"
  },
  {
    "idx_id": 38,
    "vn": "quay",
    "en": "roasting",
    "tw": "烤",
    "cn": "烤",
    "pinin": "kǎo"
  },
  {
    "idx_id": 38,
    "vn": "thịt nướng hun khói",
    "en": "barbecue",
    "tw": "燒烤",
    "cn": "烧烤",
    "pinin": "shāo kǎo"
  },
  {
    "idx_id": 38,
    "vn": "nướng",
    "en": "grilling",
    "tw": "炙烤",
    "cn": "炙烤",
    "pinin": "zhì kǎo"
  },
  {
    "idx_id": 38,
    "vn": "áp chảo",
    "en": "sautéing",
    "tw": "煸炒",
    "cn": "煸炒",
    "pinin": "biān chǎo"
  },
  {
    "idx_id": 38,
    "vn": "lên men",
    "en": "fermentation",
    "tw": "發酵",
    "cn": "发酵",
    "pinin": "fā jiào"
  },
  {
    "idx_id": 39,
    "vn": "nông dân",
    "en": "farmer",
    "tw": "農民",
    "cn": "农民",
    "pinin": "nóng mín"
  },
  {
    "idx_id": 39,
    "vn": "trang trại",
    "en": "farm",
    "tw": "農場",
    "cn": "农场",
    "pinin": "nóng cháng"
  },
  {
    "idx_id": 39,
    "vn": "cây trồng",
    "en": "crop",
    "tw": "農作物",
    "cn": "农作物",
    "pinin": "nóng zuò wù"
  },
  {
    "idx_id": 39,
    "vn": "thu hoạch",
    "en": "harvest",
    "tw": "收穫",
    "cn": "收获",
    "pinin": "shōu huò"
  },
  {
    "idx_id": 39,
    "vn": "canh tác",
    "en": "tillage",
    "tw": "耕作",
    "cn": "耕作",
    "pinin": "gēng zuò"
  },
  {
    "idx_id": 39,
    "vn": "thủy lợi",
    "en": "irrigation",
    "tw": "灌溉",
    "cn": "灌溉",
    "pinin": "guàn gài"
  },
  {
    "idx_id": 39,
    "vn": "thuốc trừ dịch hại",
    "en": "pesticide",
    "tw": "農藥",
    "cn": "农药",
    "pinin": "nóng yào"
  },
  {
    "idx_id": 39,
    "vn": "phân bón",
    "en": "fertilizer",
    "tw": "肥料",
    "cn": "肥料",
    "pinin": "féi liào"
  },
  {
    "idx_id": 39,
    "vn": "đất",
    "en": "soil",
    "tw": "土壤",
    "cn": "土壤",
    "pinin": "tǔ rǎng"
  },
  {
    "idx_id": 39,
    "vn": "ruộng lúa",
    "en": "paddy field",
    "tw": "稻田",
    "cn": "稻田",
    "pinin": "dào tián"
  },
  {
    "idx_id": 39,
    "vn": "ruộng bậc thang",
    "en": "terrace",
    "tw": "梯田",
    "cn": "梯田",
    "pinin": "tī tián"
  },
  {
    "idx_id": 39,
    "vn": "vườn cây ăn trái",
    "en": "orchard",
    "tw": "果園",
    "cn": "果园",
    "pinin": "guǒ yuán"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng tái tạo",
    "en": "renewable energy",
    "tw": "可再生能源",
    "cn": "可再生能源",
    "pinin": "kě zài shēng néng yuán"
  },
  {
    "idx_id": 40,
    "vn": "thủy điện",
    "en": "hydroelectricity",
    "tw": "水力發電",
    "cn": "水力发电",
    "pinin": "shuǐ lì fā diàn"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng gió",
    "en": "wind power",
    "tw": "風能",
    "cn": "风能",
    "pinin": "fēng néng"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng Mặt Trời",
    "en": "solar energy",
    "tw": "太陽能",
    "cn": "太阳能",
    "pinin": "tài yáng néng"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng địa nhiệt",
    "en": "geothermal energy",
    "tw": "地熱能",
    "cn": "地热能",
    "pinin": "dì rè néng"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng biển",
    "en": "marine energy",
    "tw": "海洋能",
    "cn": "海洋能",
    "pinin": "hǎi yáng néng"
  },
  {
    "idx_id": 40,
    "vn": "năng lượng hạt nhân",
    "en": "nuclear power",
    "tw": "核能",
    "cn": "核能",
    "pinin": "hé néng"
  },
  {
    "idx_id": 40,
    "vn": "nhiên liệu sinh học",
    "en": "biofuel",
    "tw": "生物燃料",
    "cn": "生物燃料",
    "pinin": "shēng wù rán liào"
  },
  {
    "idx_id": 40,
    "vn": "nhiên liệu hóa thạch",
    "en": "fossil fuel",
    "tw": "化石燃料",
    "cn": "化石燃料",
    "pinin": "huà shí rán liào"
  },
  {
    "idx_id": 40,
    "vn": "than đá",
    "en": "coal",
    "tw": "煤",
    "cn": "煤",
    "pinin": "méi"
  },
  {
    "idx_id": 40,
    "vn": "dầu mỏ",
    "en": "petroleum",
    "tw": "石油",
    "cn": "石油",
    "pinin": "shí yóu"
  },
  {
    "idx_id": 40,
    "vn": "khí thiên nhiên",
    "en": "natural gas",
    "tw": "天然氣",
    "cn": "天然气",
    "pinin": "tiān rán qì"
  },
  {
    "idx_id": 41,
    "vn": "thị trường",
    "en": "market",
    "tw": "市場",
    "cn": "市场",
    "pinin": "shì cháng"
  },
  {
    "idx_id": 41,
    "vn": "giao dịch tài chính",
    "en": "financial transaction",
    "tw": "交易",
    "cn": "交易",
    "pinin": "jiāo yì"
  },
  {
    "idx_id": 41,
    "vn": "nhập khẩu",
    "en": "import",
    "tw": "進口",
    "cn": "进口",
    "pinin": "jìn kǒu"
  },
  {
    "idx_id": 41,
    "vn": "xuất khẩu",
    "en": "export",
    "tw": "出口",
    "cn": "出口",
    "pinin": "chū kǒu"
  },
  {
    "idx_id": 41,
    "vn": "giá cả",
    "en": "price",
    "tw": "價格",
    "cn": "价格",
    "pinin": "jià gé"
  },
  {
    "idx_id": 41,
    "vn": "tiền tệ",
    "en": "currency",
    "tw": "通貨",
    "cn": "通货",
    "pinin": "tōng huò"
  },
  {
    "idx_id": 41,
    "vn": "tỷ giá hối đoái",
    "en": "exchange rate",
    "tw": "匯率",
    "cn": "汇率",
    "pinin": "huì shuài"
  },
  {
    "idx_id": 41,
    "vn": "ngoại hối",
    "en": "foreign exchange",
    "tw": "外匯",
    "cn": "外汇",
    "pinin": "wài huì"
  },
  {
    "idx_id": 41,
    "vn": "hải quan",
    "en": "customs",
    "tw": "海關",
    "cn": "海关",
    "pinin": "hǎi guān"
  },
  {
    "idx_id": 41,
    "vn": "thuế quan",
    "en": "tariff",
    "tw": "關稅",
    "cn": "关税",
    "pinin": "guān shuì"
  },
  {
    "idx_id": 41,
    "vn": "hàng hóa",
    "en": "cargo",
    "tw": "貨物",
    "cn": "货物",
    "pinin": "huò wù"
  },
  {
    "idx_id": 41,
    "vn": "công-te-nơ hóa",
    "en": "intermodal container",
    "tw": "貨櫃",
    "cn": "货柜",
    "pinin": "huò guì"
  },
  {
    "idx_id": 42,
    "vn": "vé",
    "en": "ticket",
    "tw": "門票",
    "cn": "门票",
    "pinin": "mén piào"
  },
  {
    "idx_id": 42,
    "vn": "phòng vé",
    "en": "box office",
    "tw": "售票室",
    "cn": "售票室",
    "pinin": "shòu piào shì"
  },
  {
    "idx_id": 42,
    "vn": "suất chiếu",
    "en": "showtime",
    "tw": "播放時間",
    "cn": "播放时间",
    "pinin": "bō fàng shí jiān"
  },
  {
    "idx_id": 42,
    "vn": "khán giả",
    "en": "audience",
    "tw": "觀眾",
    "cn": "观众",
    "pinin": "guān zhòng"
  },
  {
    "idx_id": 42,
    "vn": "đoạn phim giới thiệu",
    "en": "trailer",
    "tw": "預告片",
    "cn": "预告片",
    "pinin": "yù gào piàn"
  },
  {
    "idx_id": 42,
    "vn": "cảnh hậu danh đề",
    "en": "post-credits scene",
    "tw": "片尾彩蛋",
    "cn": "片尾彩蛋",
    "pinin": "piàn wěi cǎi dàn"
  },
  {
    "idx_id": 42,
    "vn": "màn chiếu",
    "en": "screen",
    "tw": "屏幕",
    "cn": "屏幕",
    "pinin": "píng mù"
  },
  {
    "idx_id": 42,
    "vn": "hàng ghế",
    "en": "row of seats",
    "tw": "一排座位",
    "cn": "一排座位",
    "pinin": "yī pái zuò wèi"
  },
  {
    "idx_id": 42,
    "vn": "thức ăn nhẹ",
    "en": "snack",
    "tw": "零食",
    "cn": "零食",
    "pinin": "líng shí"
  },
  {
    "idx_id": 42,
    "vn": "bỏng ngô",
    "en": "popcorn",
    "tw": "爆米花",
    "cn": "爆米花",
    "pinin": "bào mǐ huā"
  },
  {
    "idx_id": 42,
    "vn": "đồ uống nhẹ",
    "en": "soft drink",
    "tw": "汽水",
    "cn": "汽水",
    "pinin": "qì shuǐ"
  },
  {
    "idx_id": 42,
    "vn": "áp phích",
    "en": "poster",
    "tw": "海報",
    "cn": "海报",
    "pinin": "hǎi bào"
  },
  {
    "idx_id": 43,
    "vn": "nước biển",
    "en": "seawater",
    "tw": "海水",
    "cn": "海水",
    "pinin": "hǎi shuǐ"
  },
  {
    "idx_id": 43,
    "vn": "sóng biển",
    "en": "sea wave",
    "tw": "海浪",
    "cn": "海浪",
    "pinin": "hǎi làng"
  },
  {
    "idx_id": 43,
    "vn": "sóng thần",
    "en": "tsunami",
    "tw": "海嘯",
    "cn": "海啸",
    "pinin": "hǎi xiào"
  },
  {
    "idx_id": 43,
    "vn": "hải lưu",
    "en": "ocean current",
    "tw": "海流",
    "cn": "海流",
    "pinin": "hǎi liú"
  },
  {
    "idx_id": 43,
    "vn": "bờ biển",
    "en": "coast",
    "tw": "海岸",
    "cn": "海岸",
    "pinin": "hǎi àn"
  },
  {
    "idx_id": 43,
    "vn": "bãi biển",
    "en": "beach",
    "tw": "海灘",
    "cn": "海滩",
    "pinin": "hǎi tān"
  },
  {
    "idx_id": 43,
    "vn": "mực nước biển",
    "en": "sea level",
    "tw": "海平面",
    "cn": "海平面",
    "pinin": "hǎi píng miàn"
  },
  {
    "idx_id": 43,
    "vn": "eo biển",
    "en": "strait",
    "tw": "海峽",
    "cn": "海峡",
    "pinin": "hǎi xiá"
  },
  {
    "idx_id": 43,
    "vn": "vịnh",
    "en": "bay",
    "tw": "海灣",
    "cn": "海湾",
    "pinin": "hǎi wān"
  },
  {
    "idx_id": 43,
    "vn": "mũi đất",
    "en": "cape",
    "tw": "海岬",
    "cn": "海岬",
    "pinin": "hǎi jiǎ"
  },
  {
    "idx_id": 43,
    "vn": "bồn trũng đại dương",
    "en": "oceanic basin",
    "tw": "海盆",
    "cn": "海盆",
    "pinin": "hǎi pén"
  },
  {
    "idx_id": 43,
    "vn": "rãnh đại dương",
    "en": "oceanic trench",
    "tw": "海溝",
    "cn": "海沟",
    "pinin": "hǎi gōu"
  },
  {
    "idx_id": 44,
    "vn": "cảnh khuyển",
    "en": "police dog",
    "tw": "警犬",
    "cn": "警犬",
    "pinin": "jǐng quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó nghiệp vụ",
    "en": "dogs in warfare",
    "tw": "軍犬",
    "cn": "军犬",
    "pinin": "jūn quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó chữa cháy",
    "en": "fire fighting dog",
    "tw": "消防犬",
    "cn": "消防犬",
    "pinin": "xiāo fáng quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó bảo vệ",
    "en": "guard dog",
    "tw": "護衛犬",
    "cn": "护卫犬",
    "pinin": "hù wèi quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó dẫn đường",
    "en": "guide dog",
    "tw": "導盲犬",
    "cn": "导盲犬",
    "pinin": "dǎo máng quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó phát hiện ma tuý",
    "en": "drug detection dog",
    "tw": "緝毒犬",
    "cn": "缉毒犬",
    "pinin": "jī dú quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó tìm kiếm và giải cứu",
    "en": "search and rescue dog",
    "tw": "搜救犬",
    "cn": "搜救犬",
    "pinin": "sōu jiù quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó nấm cục",
    "en": "truffle dog",
    "tw": "松露犬",
    "cn": "松露犬",
    "pinin": "sōng lòu quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó săn",
    "en": "hunting dog",
    "tw": "獵犬",
    "cn": "猎犬",
    "pinin": "liè quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó chăn cừu",
    "en": "herding dog",
    "tw": "牧羊犬",
    "cn": "牧羊犬",
    "pinin": "mù yáng quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó kéo xe",
    "en": "sled dog",
    "tw": "雪橇犬",
    "cn": "雪橇犬",
    "pinin": "xuě qiāo quǎn"
  },
  {
    "idx_id": 44,
    "vn": "chó chọi",
    "en": "fighting dog",
    "tw": "鬥犬",
    "cn": "斗犬",
    "pinin": "dǒu quǎn"
  },
  {
    "idx_id": 45,
    "vn": "tiền tệ",
    "en": "currency",
    "tw": "通貨",
    "cn": "通货",
    "pinin": "tōng huò"
  },
  {
    "idx_id": 45,
    "vn": "tiền giấy",
    "en": "banknote",
    "tw": "紙幣",
    "cn": "纸币",
    "pinin": "zhǐ bì"
  },
  {
    "idx_id": 45,
    "vn": "đồng xu",
    "en": "coin",
    "tw": "硬幣",
    "cn": "硬币",
    "pinin": "yìng bì"
  },
  {
    "idx_id": 45,
    "vn": "tiền định danh",
    "en": "fiat money",
    "tw": "法定貨幣",
    "cn": "法定货币",
    "pinin": "fǎ dìng huò bì"
  },
  {
    "idx_id": 45,
    "vn": "tiền kỹ thuật số",
    "en": "digital currency",
    "tw": "數位貨幣",
    "cn": "数位货币",
    "pinin": "shù wèi huò bì"
  },
  {
    "idx_id": 45,
    "vn": "tiền ảo",
    "en": "virtual currency",
    "tw": "虛擬貨幣",
    "cn": "虚拟货币",
    "pinin": "xū nǐ huò bì"
  },
  {
    "idx_id": 45,
    "vn": "tiền mã hóa",
    "en": "cryptocurrency",
    "tw": "加密貨幣",
    "cn": "加密货币",
    "pinin": "jiā mì huò bì"
  },
  {
    "idx_id": 45,
    "vn": "tiền hàng hóa",
    "en": "commodity money",
    "tw": "商品貨幣",
    "cn": "商品货币",
    "pinin": "shāng pǐn huò bì"
  },
  {
    "idx_id": 45,
    "vn": "kim loại quý",
    "en": "precious metal",
    "tw": "貴金屬",
    "cn": "贵金属",
    "pinin": "guì jīn shǔ"
  },
  {
    "idx_id": 45,
    "vn": "ngọc",
    "en": "gemstone",
    "tw": "寶石",
    "cn": "宝石",
    "pinin": "bǎo shí"
  },
  {
    "idx_id": 45,
    "vn": "trang sức",
    "en": "jewellery",
    "tw": "珠寶",
    "cn": "珠宝",
    "pinin": "zhū bǎo"
  },
  {
    "idx_id": 45,
    "vn": "gia súc",
    "en": "livestock",
    "tw": "家畜",
    "cn": "家畜",
    "pinin": "jiā chù"
  },
  {
    "idx_id": 46,
    "vn": "vũ trụ",
    "en": "universe",
    "tw": "宇宙",
    "cn": "宇宙",
    "pinin": "yǔ zhòu"
  },
  {
    "idx_id": 46,
    "vn": "không gian",
    "en": "space",
    "tw": "空間",
    "cn": "空间",
    "pinin": "kōng jiān"
  },
  {
    "idx_id": 46,
    "vn": "thời gian",
    "en": "time",
    "tw": "時間",
    "cn": "时间",
    "pinin": "shí jiān"
  },
  {
    "idx_id": 46,
    "vn": "vật chất",
    "en": "matter",
    "tw": "物質",
    "cn": "物质",
    "pinin": "wù zhì"
  },
  {
    "idx_id": 46,
    "vn": "hạt căn bản",
    "en": "particle",
    "tw": "粒子",
    "cn": "粒子",
    "pinin": "lì zǐ"
  },
  {
    "idx_id": 46,
    "vn": "ánh sáng",
    "en": "light",
    "tw": "光",
    "cn": "光",
    "pinin": "guāng"
  },
  {
    "idx_id": 46,
    "vn": "âm thanh",
    "en": "sound",
    "tw": "聲",
    "cn": "声",
    "pinin": "shēng"
  },
  {
    "idx_id": 46,
    "vn": "sóng",
    "en": "wave",
    "tw": "波",
    "cn": "波",
    "pinin": "bō"
  },
  {
    "idx_id": 46,
    "vn": "trường",
    "en": "field",
    "tw": "場",
    "cn": "场",
    "pinin": "cháng"
  },
  {
    "idx_id": 46,
    "vn": "lực",
    "en": "force",
    "tw": "力",
    "cn": "力",
    "pinin": "lì"
  },
  {
    "idx_id": 46,
    "vn": "năng lượng",
    "en": "energy",
    "tw": "能量",
    "cn": "能量",
    "pinin": "néng liàng"
  },
  {
    "idx_id": 46,
    "vn": "không-thời gian",
    "en": "spacetime",
    "tw": "時空",
    "cn": "时空",
    "pinin": "shí kōng"
  },
  {
    "idx_id": 47,
    "vn": "giây",
    "en": "second",
    "tw": "秒",
    "cn": "秒",
    "pinin": "miǎo"
  },
  {
    "idx_id": 47,
    "vn": "phút",
    "en": "minute",
    "tw": "分",
    "cn": "分",
    "pinin": "fēn"
  },
  {
    "idx_id": 47,
    "vn": "giờ",
    "en": "hour",
    "tw": "時",
    "cn": "时",
    "pinin": "shí"
  },
  {
    "idx_id": 47,
    "vn": "ngày",
    "en": "day",
    "tw": "日",
    "cn": "日",
    "pinin": "rì"
  },
  {
    "idx_id": 47,
    "vn": "tuần",
    "en": "week",
    "tw": "周",
    "cn": "周",
    "pinin": "zhōu"
  },
  {
    "idx_id": 47,
    "vn": "tháng",
    "en": "month",
    "tw": "月",
    "cn": "月",
    "pinin": "yuè"
  },
  {
    "idx_id": 47,
    "vn": "quý",
    "en": "quarter",
    "tw": "季",
    "cn": "季",
    "pinin": "jì"
  },
  {
    "idx_id": 47,
    "vn": "năm",
    "en": "year",
    "tw": "年",
    "cn": "年",
    "pinin": "nián"
  },
  {
    "idx_id": 47,
    "vn": "thập niên",
    "en": "decade",
    "tw": "年代",
    "cn": "年代",
    "pinin": "nián dài"
  },
  {
    "idx_id": 47,
    "vn": "giáp tý",
    "en": "sixty years",
    "tw": "甲子",
    "cn": "甲子",
    "pinin": "jiǎ zǐ"
  },
  {
    "idx_id": 47,
    "vn": "thế kỷ",
    "en": "century",
    "tw": "世紀",
    "cn": "世纪",
    "pinin": "shì jì"
  },
  {
    "idx_id": 47,
    "vn": "thiên niên kỷ",
    "en": "millennium",
    "tw": "千紀",
    "cn": "千纪",
    "pinin": "qiān jì"
  },
  {
    "idx_id": 48,
    "vn": "tranh sơn dầu",
    "en": "oil painting",
    "tw": "油畫",
    "cn": "油画",
    "pinin": "yóu huà"
  },
  {
    "idx_id": 48,
    "vn": "tranh phấn tiên",
    "en": "pastel painting",
    "tw": "粉彩",
    "cn": "粉彩",
    "pinin": "fěn cǎi"
  },
  {
    "idx_id": 48,
    "vn": "tranh khắc bản",
    "en": "lithography",
    "tw": "版畫",
    "cn": "版画",
    "pinin": "bǎn huà"
  },
  {
    "idx_id": 48,
    "vn": "màu nước",
    "en": "watercolor painting",
    "tw": "水彩",
    "cn": "水彩",
    "pinin": "shuǐ cǎi"
  },
  {
    "idx_id": 48,
    "vn": "tranh thủy mặc",
    "en": "ink wash painting",
    "tw": "水墨畫",
    "cn": "水墨画",
    "pinin": "shuǐ mò huà"
  },
  {
    "idx_id": 48,
    "vn": "thư pháp",
    "en": "calligraphy",
    "tw": "書法",
    "cn": "书法",
    "pinin": "shū fǎ"
  },
  {
    "idx_id": 48,
    "vn": "khắc dấu",
    "en": "seal carving",
    "tw": "篆刻",
    "cn": "篆刻",
    "pinin": "zhuàn kè"
  },
  {
    "idx_id": 48,
    "vn": "tranh minh hoạ",
    "en": "illustration",
    "tw": "插畫",
    "cn": "插画",
    "pinin": "chā huà"
  },
  {
    "idx_id": 48,
    "vn": "phác hoạ",
    "en": "sketch",
    "tw": "素描",
    "cn": "素描",
    "pinin": "sù miáo"
  },
  {
    "idx_id": 48,
    "vn": "khí hoạ",
    "en": "croquis",
    "tw": "速寫",
    "cn": "速写",
    "pinin": "sù xiě"
  },
  {
    "idx_id": 48,
    "vn": "truyện tranh",
    "en": "comics",
    "tw": "漫畫",
    "cn": "漫画",
    "pinin": "màn huà"
  },
  {
    "idx_id": 48,
    "vn": "nghệ thuật điểm ảnh",
    "en": "pixel art",
    "tw": "像素畫",
    "cn": "像素画",
    "pinin": "xiàng sù huà"
  },
  {
    "idx_id": 49,
    "vn": "son môi",
    "en": "lipstick",
    "tw": "口紅",
    "cn": "口红",
    "pinin": "kǒu hóng"
  },
  {
    "idx_id": 49,
    "vn": "sáp dưỡng môi",
    "en": "lip balm",
    "tw": "潤唇膏",
    "cn": "润唇膏",
    "pinin": "rùn chún gāo"
  },
  {
    "idx_id": 49,
    "vn": "kem nền",
    "en": "foundation cream",
    "tw": "粉底",
    "cn": "粉底",
    "pinin": "fěn dǐ"
  },
  {
    "idx_id": 49,
    "vn": "phấn má hồng",
    "en": "rouge",
    "tw": "胭脂",
    "cn": "胭脂",
    "pinin": "yān zhī"
  },
  {
    "idx_id": 49,
    "vn": "mặt nạ dưỡng ẩm",
    "en": "moisturizing mask",
    "tw": "面膜",
    "cn": "面膜",
    "pinin": "miàn mó"
  },
  {
    "idx_id": 49,
    "vn": "toner",
    "en": "toner",
    "tw": "化妝水",
    "cn": "化妆水",
    "pinin": "huà zhuāng shuǐ"
  },
  {
    "idx_id": 49,
    "vn": "bút chì lông mày",
    "en": "eyebrow pencil",
    "tw": "眉筆",
    "cn": "眉笔",
    "pinin": "méi bǐ"
  },
  {
    "idx_id": 49,
    "vn": "mascara",
    "en": "mascara",
    "tw": "睫毛膏",
    "cn": "睫毛膏",
    "pinin": "jié máo gāo"
  },
  {
    "idx_id": 49,
    "vn": "nối mi",
    "en": "eyelash extensions",
    "tw": "假睫毛",
    "cn": "假睫毛",
    "pinin": "jiǎ jié máo"
  },
  {
    "idx_id": 49,
    "vn": "phấn mắt",
    "en": "eye shadow",
    "tw": "眼影",
    "cn": "眼影",
    "pinin": "yǎn yǐng"
  },
  {
    "idx_id": 49,
    "vn": "sơn móng",
    "en": "nail polish",
    "tw": "指甲油",
    "cn": "指甲油",
    "pinin": "zhǐ jiǎ yóu"
  },
  {
    "idx_id": 49,
    "vn": "nước hoa",
    "en": "perfume",
    "tw": "香水",
    "cn": "香水",
    "pinin": "xiāng shuǐ"
  },
  {
    "idx_id": 50,
    "vn": "ong chúa",
    "en": "queen bee",
    "tw": "蜂后",
    "cn": "蜂后",
    "pinin": "fēng hòu"
  },
  {
    "idx_id": 50,
    "vn": "ong đực",
    "en": "drone",
    "tw": "雄蜂",
    "cn": "雄蜂",
    "pinin": "xióng fēng"
  },
  {
    "idx_id": 50,
    "vn": "ong thợ",
    "en": "worker bee",
    "tw": "工蜂",
    "cn": "工蜂",
    "pinin": "gōng fēng"
  },
  {
    "idx_id": 50,
    "vn": "nhộng",
    "en": "pupa",
    "tw": "蛹",
    "cn": "蛹",
    "pinin": "yǒng"
  },
  {
    "idx_id": 50,
    "vn": "mật ong",
    "en": "honey",
    "tw": "蜂蜜",
    "cn": "蜂蜜",
    "pinin": "fēng mì"
  },
  {
    "idx_id": 50,
    "vn": "sữa ong chúa",
    "en": "royal jelly",
    "tw": "蜂王漿",
    "cn": "蜂王浆",
    "pinin": "fēng wáng jiāng"
  },
  {
    "idx_id": 50,
    "vn": "sáp ong",
    "en": "beeswax",
    "tw": "蜂蠟",
    "cn": "蜂蜡",
    "pinin": "fēng là"
  },
  {
    "idx_id": 50,
    "vn": "keo ong",
    "en": "propolis",
    "tw": "蜂膠",
    "cn": "蜂胶",
    "pinin": "fēng jiāo"
  },
  {
    "idx_id": 50,
    "vn": "tổ ong",
    "en": "beehive",
    "tw": "蜂巢",
    "cn": "蜂巢",
    "pinin": "fēng cháo"
  },
  {
    "idx_id": 50,
    "vn": "tảng ong",
    "en": "honeycomb",
    "tw": "蜂房",
    "cn": "蜂房",
    "pinin": "fēng fáng"
  },
  {
    "idx_id": 50,
    "vn": "nọc ong",
    "en": "apitoxin",
    "tw": "蜂毒",
    "cn": "蜂毒",
    "pinin": "fēng dú"
  },
  {
    "idx_id": 50,
    "vn": "ong đốt",
    "en": "bee sting",
    "tw": "蜜蜂蜇",
    "cn": "蜜蜂蜇",
    "pinin": "mì fēng zhé"
  },
  {
    "idx_id": 51,
    "vn": "thịt muối",
    "en": "bacon",
    "tw": "培根",
    "cn": "培根",
    "pinin": "péi gēn"
  },
  {
    "idx_id": 51,
    "vn": "giăm bông",
    "en": "ham",
    "tw": "火腿",
    "cn": "火腿",
    "pinin": "huǒ tuǐ"
  },
  {
    "idx_id": 51,
    "vn": "xúc xích",
    "en": "sausage",
    "tw": "香腸",
    "cn": "香肠",
    "pinin": "xiāng cháng"
  },
  {
    "idx_id": 51,
    "vn": "hot dog",
    "en": "hot dog",
    "tw": "熱狗",
    "cn": "热狗",
    "pinin": "rè gǒu"
  },
  {
    "idx_id": 51,
    "vn": "miếng thịt",
    "en": "steak",
    "tw": "肉排",
    "cn": "肉排",
    "pinin": "ròu pái"
  },
  {
    "idx_id": 51,
    "vn": "nhục can",
    "en": "bakkwa",
    "tw": "肉乾",
    "cn": "肉干",
    "pinin": "ròu gān"
  },
  {
    "idx_id": 51,
    "vn": "thịt băm viên",
    "en": "hamburg steak",
    "tw": "漢堡排",
    "cn": "汉堡排",
    "pinin": "hàn bǎo pái"
  },
  {
    "idx_id": 51,
    "vn": "thịt chiên xù",
    "en": "breaded cutlet",
    "tw": "吉列",
    "cn": "吉列",
    "pinin": "jí liè"
  },
  {
    "idx_id": 51,
    "vn": "thịt hộp Spam",
    "en": "Spam",
    "tw": "午餐肉",
    "cn": "午餐肉",
    "pinin": "wǔ cān ròu"
  },
  {
    "idx_id": 51,
    "vn": "thịt viên",
    "en": "meatball",
    "tw": "肉丸",
    "cn": "肉丸",
    "pinin": "ròu wán"
  },
  {
    "idx_id": 51,
    "vn": "giò",
    "en": "meatloaf",
    "tw": "肉卷",
    "cn": "肉卷",
    "pinin": "ròu juàn"
  },
  {
    "idx_id": 51,
    "vn": "thịt xiên",
    "en": "kebab",
    "tw": "烤串",
    "cn": "烤串",
    "pinin": "kǎo chuàn"
  },
  {
    "idx_id": 52,
    "vn": "mùa xuân",
    "en": "spring",
    "tw": "春季",
    "cn": "春季",
    "pinin": "chūn jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa hè",
    "en": "summer",
    "tw": "夏季",
    "cn": "夏季",
    "pinin": "xià jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa thu",
    "en": "autumn",
    "tw": "秋季",
    "cn": "秋季",
    "pinin": "qiū jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa đông",
    "en": "winter",
    "tw": "冬季",
    "cn": "冬季",
    "pinin": "dōng jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa ôn đới",
    "en": "temperate season",
    "tw": "溫帶季節",
    "cn": "温带季节",
    "pinin": "wēn dài jì jié"
  },
  {
    "idx_id": 52,
    "vn": "mùa mưa",
    "en": "wet season",
    "tw": "雨季",
    "cn": "雨季",
    "pinin": "yǔ jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa khô",
    "en": "dry season",
    "tw": "旱季",
    "cn": "旱季",
    "pinin": "hàn jì"
  },
  {
    "idx_id": 52,
    "vn": "mùa nhiệt đới",
    "en": "tropical season",
    "tw": "熱帶季節",
    "cn": "热带季节",
    "pinin": "rè dài jì jié"
  },
  {
    "idx_id": 52,
    "vn": "ban ngày vùng cực",
    "en": "polar day",
    "tw": "極晝",
    "cn": "极昼",
    "pinin": "jí zhòu"
  },
  {
    "idx_id": 52,
    "vn": "ban đêm vùng cực",
    "en": "polar night",
    "tw": "極夜",
    "cn": "极夜",
    "pinin": "jí yè"
  },
  {
    "idx_id": 52,
    "vn": "mùa hàn đới",
    "en": "arctic season",
    "tw": "寒帶季節",
    "cn": "寒带季节",
    "pinin": "hán dài jì jié"
  },
  {
    "idx_id": 52,
    "vn": "vùng cực",
    "en": "polar regions of Earth",
    "tw": "極地",
    "cn": "极地",
    "pinin": "jí dì"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh mặt đất",
    "en": "ground warfare",
    "tw": "陸戰",
    "cn": "陆战",
    "pinin": "lù zhàn"
  },
  {
    "idx_id": 53,
    "vn": "hải chiến",
    "en": "naval warfare",
    "tw": "海戰",
    "cn": "海战",
    "pinin": "hǎi zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh trên không",
    "en": "aerial warfare",
    "tw": "空戰",
    "cn": "空战",
    "pinin": "kōng zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh du kích",
    "en": "guerrilla warfare",
    "tw": "游擊戰",
    "cn": "游击战",
    "pinin": "yóu jī zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh tiêu hao",
    "en": "attrition warfare",
    "tw": "消耗戰",
    "cn": "消耗战",
    "pinin": "xiāo hào zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh kinh tế",
    "en": "economic warfare",
    "tw": "經濟戰",
    "cn": "经济战",
    "pinin": "jīng jì zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh thương mại",
    "en": "trade war",
    "tw": "貿易戰",
    "cn": "贸易战",
    "pinin": "mào yì zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh tâm lý",
    "en": "psychological warfare",
    "tw": "心理戰",
    "cn": "心理战",
    "pinin": "xīn lǐ zhàn"
  },
  {
    "idx_id": 53,
    "vn": "tác chiến điện tử",
    "en": "electronic warfare",
    "tw": "電子戰",
    "cn": "电子战",
    "pinin": "diàn zǐ zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh mạng",
    "en": "cyberwarfare",
    "tw": "網絡戰",
    "cn": "网络战",
    "pinin": "wǎng luò zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh thông tin",
    "en": "information warfare",
    "tw": "資訊戰",
    "cn": "资讯战",
    "pinin": "zī xùn zhàn"
  },
  {
    "idx_id": 53,
    "vn": "chiến tranh toàn diện",
    "en": "total war",
    "tw": "總體戰",
    "cn": "总体战",
    "pinin": "zǒng tǐ zhàn"
  },
  {
    "idx_id": 54,
    "vn": "người chủ",
    "en": "employer",
    "tw": "僱主",
    "cn": "雇主",
    "pinin": "gù zhǔ"
  },
  {
    "idx_id": 54,
    "vn": "người lao động",
    "en": "employee",
    "tw": "僱員",
    "cn": "雇员",
    "pinin": "gù yuán"
  },
  {
    "idx_id": 54,
    "vn": "thuê",
    "en": "to hire",
    "tw": "僱用",
    "cn": "雇用",
    "pinin": "gù yòng"
  },
  {
    "idx_id": 54,
    "vn": "đuổi việc",
    "en": "to dismiss",
    "tw": "解僱",
    "cn": "解雇",
    "pinin": "jiě gù"
  },
  {
    "idx_id": 54,
    "vn": "tuyển dụng",
    "en": "to recruit",
    "tw": "招聘",
    "cn": "招聘",
    "pinin": "zhāo pìn"
  },
  {
    "idx_id": 54,
    "vn": "hồ sơ xin việc",
    "en": "resume",
    "tw": "履歷",
    "cn": "履历",
    "pinin": "lǚ lì"
  },
  {
    "idx_id": 54,
    "vn": "phỏng vấn",
    "en": "interview",
    "tw": "面試",
    "cn": "面试",
    "pinin": "miàn shì"
  },
  {
    "idx_id": 54,
    "vn": "hợp đồng lao động",
    "en": "employment contract",
    "tw": "勞動契約",
    "cn": "劳动契约",
    "pinin": "láo dòng qì yuē"
  },
  {
    "idx_id": 54,
    "vn": "tiền lương",
    "en": "salary",
    "tw": "工資",
    "cn": "工资",
    "pinin": "gōng zī"
  },
  {
    "idx_id": 54,
    "vn": "tiền thưởng",
    "en": "bonus",
    "tw": "獎金",
    "cn": "奖金",
    "pinin": "jiǎng jīn"
  },
  {
    "idx_id": 54,
    "vn": "nghỉ việc",
    "en": "leave of absence",
    "tw": "休假",
    "cn": "休假",
    "pinin": "xiū jià"
  },
  {
    "idx_id": 54,
    "vn": "bảo hiểm y tế",
    "en": "medical insurance",
    "tw": "醫療保險",
    "cn": "医疗保险",
    "pinin": "yī liáo bǎo xiǎn"
  },
  {
    "idx_id": 55,
    "vn": "máy bay",
    "en": "airplane",
    "tw": "飛機",
    "cn": "飞机",
    "pinin": "fēi jī"
  },
  {
    "idx_id": 55,
    "vn": "cất cánh",
    "en": "takeoff",
    "tw": "起飛",
    "cn": "起飞",
    "pinin": "qǐ fēi"
  },
  {
    "idx_id": 55,
    "vn": "hạ cánh",
    "en": "landing",
    "tw": "著陸",
    "cn": "着陆",
    "pinin": "zhuó lù"
  },
  {
    "idx_id": 55,
    "vn": "sân bay",
    "en": "airport",
    "tw": "機場",
    "cn": "机场",
    "pinin": "jī chǎng"
  },
  {
    "idx_id": 55,
    "vn": "vé máy bay",
    "en": "airline ticket",
    "tw": "機票",
    "cn": "机票",
    "pinin": "jī piào"
  },
  {
    "idx_id": 55,
    "vn": "cửa",
    "en": "gate",
    "tw": "登機閘口",
    "cn": "登机闸口",
    "pinin": "dēng jī zhá kǒu"
  },
  {
    "idx_id": 55,
    "vn": "cầu thang máy bay",
    "en": "airstair",
    "tw": "登机梯",
    "cn": "登机梯",
    "pinin": "dēng jī tī"
  },
  {
    "idx_id": 55,
    "vn": "phòng chờ sân bay",
    "en": "airport lounge",
    "tw": "機場休息室",
    "cn": "机场休息室",
    "pinin": "jī chǎng xiū xī shì"
  },
  {
    "idx_id": 55,
    "vn": "ghế hạng nhất",
    "en": "first class",
    "tw": "頭等艙",
    "cn": "头等舱",
    "pinin": "tóu děng cāng"
  },
  {
    "idx_id": 55,
    "vn": "ghế hạng thương gia",
    "en": "business class",
    "tw": "商務艙",
    "cn": "商务舱",
    "pinin": "shāng wù cāng"
  },
  {
    "idx_id": 55,
    "vn": "ghế hạng phổ thông",
    "en": "economy class",
    "tw": "經濟艙",
    "cn": "经济舱",
    "pinin": "jīng jì cāng"
  },
  {
    "idx_id": 55,
    "vn": "kiểm tra an ninh",
    "en": "security check",
    "tw": "安全檢查",
    "cn": "安全检查",
    "pinin": "ān quán jiǎn chá"
  }
]

export const vocas = data.reduce((a,c) => {
  if (!(c.idx_id in a)) {
    a[c.idx_id] = []
  }
  a[c.idx_id].push({
    vi: c.vn,
    en: c.en,
    tw: c.tw,
    cn: c.cn,
    pinin: c.pinin
  })
  return a
}, {})